/* eslint-disable */
import axios from 'axios'
import qs from 'qs'
let domain = ''
export const getDomain = () => {
  return domain
}
export const setDomain = ($domain) => {
  domain = $domain
}
export const request = (method, url, body, queryParameters, form, config) => {
  method = method.toLowerCase()
  let keys = Object.keys(queryParameters)
  let queryUrl = url
  if (keys.length > 0) {
    queryUrl = url + '?' + qs.stringify(queryParameters)
  }
  // let queryUrl = url+(keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
  if (body) {
    return axios[method](queryUrl, body, config)
  } else if (method === 'get') {
    return axios[method](queryUrl, {
      params: form
    }, config)
  } else {
    return axios[method](queryUrl, qs.stringify(form), config)
  }
}
/*==========================================================
 *                    
 ==========================================================*/
/**
 * Add a new book type
 * request: addBookType
 * url: addBookTypeURL
 * method: addBookType_TYPE
 * raw_url: addBookType_RAW_URL
 * @param body - 
 */
export const addBookType = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/book-type/add'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addBookType_RAW_URL = function() {
  return '/book-type/add'
}
export const addBookType_TYPE = function() {
  return 'post'
}
export const addBookTypeURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/book-type/add'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all book types for breed
 * request: getBookTypes
 * url: getBookTypesURL
 * method: getBookTypes_TYPE
 * raw_url: getBookTypes_RAW_URL
 */
export const getBookTypes = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/book-type/all'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getBookTypes_RAW_URL = function() {
  return '/book-type/all'
}
export const getBookTypes_TYPE = function() {
  return 'get'
}
export const getBookTypesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/book-type/all'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete a book type
 * request: deleteBookType
 * url: deleteBookTypeURL
 * method: deleteBookType_TYPE
 * raw_url: deleteBookType_RAW_URL
 * @param id - 
 */
export const deleteBookType = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/book-type/delete/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteBookType_RAW_URL = function() {
  return '/book-type/delete/{id}'
}
export const deleteBookType_TYPE = function() {
  return 'delete'
}
export const deleteBookTypeURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/book-type/delete/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search book types
 * request: searchBookType
 * url: searchBookTypeURL
 * method: searchBookType_TYPE
 * raw_url: searchBookType_RAW_URL
 * @param body - 
 */
export const searchBookType = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/book-type/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchBookType_RAW_URL = function() {
  return '/book-type/search'
}
export const searchBookType_TYPE = function() {
  return 'post'
}
export const searchBookTypeURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/book-type/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count book types matching search criteria
 * request: searchBookTypeCount
 * url: searchBookTypeCountURL
 * method: searchBookTypeCount_TYPE
 * raw_url: searchBookTypeCount_RAW_URL
 * @param body - 
 */
export const searchBookTypeCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/book-type/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchBookTypeCount_RAW_URL = function() {
  return '/book-type/search/count'
}
export const searchBookTypeCount_TYPE = function() {
  return 'post'
}
export const searchBookTypeCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/book-type/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Update a book type
 * request: updateBookType
 * url: updateBookTypeURL
 * method: updateBookType_TYPE
 * raw_url: updateBookType_RAW_URL
 * @param id - 
 * @param body - 
 */
export const updateBookType = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/book-type/update/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateBookType_RAW_URL = function() {
  return '/book-type/update/{id}'
}
export const updateBookType_TYPE = function() {
  return 'put'
}
export const updateBookTypeURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/book-type/update/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all cities
 * request: getAllCities
 * url: getAllCitiesURL
 * method: getAllCities_TYPE
 * raw_url: getAllCities_RAW_URL
 */
export const getAllCities = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/city/all'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllCities_RAW_URL = function() {
  return '/city/all'
}
export const getAllCities_TYPE = function() {
  return 'get'
}
export const getAllCitiesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/city/all'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all countries
 * request: getCountries
 * url: getCountriesURL
 * method: getCountries_TYPE
 * raw_url: getCountries_RAW_URL
 */
export const getCountries = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/countries'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCountries_RAW_URL = function() {
  return '/countries'
}
export const getCountries_TYPE = function() {
  return 'get'
}
export const getCountriesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/countries'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Create a covering agreement
 * request: createCoveringAgreement
 * url: createCoveringAgreementURL
 * method: createCoveringAgreement_TYPE
 * raw_url: createCoveringAgreement_RAW_URL
 * @param body - 
 */
export const createCoveringAgreement = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-agreements'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createCoveringAgreement_RAW_URL = function() {
  return '/covering-agreements'
}
export const createCoveringAgreement_TYPE = function() {
  return 'post'
}
export const createCoveringAgreementURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-agreements'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Update a covering agreement
 * request: updateCoveringAgreement
 * url: updateCoveringAgreementURL
 * method: updateCoveringAgreement_TYPE
 * raw_url: updateCoveringAgreement_RAW_URL
 * @param body - 
 */
export const updateCoveringAgreement = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-agreements'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateCoveringAgreement_RAW_URL = function() {
  return '/covering-agreements'
}
export const updateCoveringAgreement_TYPE = function() {
  return 'put'
}
export const updateCoveringAgreementURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-agreements'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all covering agreement types
 * request: getAllCoveringTypes
 * url: getAllCoveringTypesURL
 * method: getAllCoveringTypes_TYPE
 * raw_url: getAllCoveringTypes_RAW_URL
 */
export const getAllCoveringTypes = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-agreements/all-types'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllCoveringTypes_RAW_URL = function() {
  return '/covering-agreements/all-types'
}
export const getAllCoveringTypes_TYPE = function() {
  return 'get'
}
export const getAllCoveringTypesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-agreements/all-types'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search covering agreements for a stallion
 * request: searchCoveringAgreements
 * url: searchCoveringAgreementsURL
 * method: searchCoveringAgreements_TYPE
 * raw_url: searchCoveringAgreements_RAW_URL
 * @param stallionId - 
 * @param body - 
 */
export const searchCoveringAgreements = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-agreements/horse/{stallionId}/search'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{stallionId}', `${parameters['stallionId']}`)
  if (parameters['stallionId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: stallionId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchCoveringAgreements_RAW_URL = function() {
  return '/covering-agreements/horse/{stallionId}/search'
}
export const searchCoveringAgreements_TYPE = function() {
  return 'post'
}
export const searchCoveringAgreementsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-agreements/horse/{stallionId}/search'
  path = path.replace('{stallionId}', `${parameters['stallionId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count covering agreements for a stallion
 * request: searchCoveringAgreementsCount
 * url: searchCoveringAgreementsCountURL
 * method: searchCoveringAgreementsCount_TYPE
 * raw_url: searchCoveringAgreementsCount_RAW_URL
 * @param stallionId - 
 * @param body - 
 */
export const searchCoveringAgreementsCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-agreements/horse/{stallionId}/search/count'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{stallionId}', `${parameters['stallionId']}`)
  if (parameters['stallionId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: stallionId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchCoveringAgreementsCount_RAW_URL = function() {
  return '/covering-agreements/horse/{stallionId}/search/count'
}
export const searchCoveringAgreementsCount_TYPE = function() {
  return 'post'
}
export const searchCoveringAgreementsCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-agreements/horse/{stallionId}/search/count'
  path = path.replace('{stallionId}', `${parameters['stallionId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get last covering agreement type for a stallion
 * request: getLastCoveringAgreementType
 * url: getLastCoveringAgreementTypeURL
 * method: getLastCoveringAgreementType_TYPE
 * raw_url: getLastCoveringAgreementType_RAW_URL
 * @param stallionId - 
 */
export const getLastCoveringAgreementType = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-agreements/last-agreement-type/{stallionId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{stallionId}', `${parameters['stallionId']}`)
  if (parameters['stallionId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: stallionId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getLastCoveringAgreementType_RAW_URL = function() {
  return '/covering-agreements/last-agreement-type/{stallionId}'
}
export const getLastCoveringAgreementType_TYPE = function() {
  return 'get'
}
export const getLastCoveringAgreementTypeURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-agreements/last-agreement-type/{stallionId}'
  path = path.replace('{stallionId}', `${parameters['stallionId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete a covering agreement
 * request: deleteCoveringAgreement
 * url: deleteCoveringAgreementURL
 * method: deleteCoveringAgreement_TYPE
 * raw_url: deleteCoveringAgreement_RAW_URL
 * @param id - 
 */
export const deleteCoveringAgreement = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-agreements/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteCoveringAgreement_RAW_URL = function() {
  return '/covering-agreements/{id}'
}
export const deleteCoveringAgreement_TYPE = function() {
  return 'delete'
}
export const deleteCoveringAgreementURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-agreements/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Create a covering certificate
 * request: createCoveringCertificate
 * url: createCoveringCertificateURL
 * method: createCoveringCertificate_TYPE
 * raw_url: createCoveringCertificate_RAW_URL
 * @param body - 
 */
export const createCoveringCertificate = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-certificate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createCoveringCertificate_RAW_URL = function() {
  return '/covering-certificate'
}
export const createCoveringCertificate_TYPE = function() {
  return 'post'
}
export const createCoveringCertificateURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-certificate'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get available covering certificates by query
 * request: getAvailableCoveringCertificatesByQuery
 * url: getAvailableCoveringCertificatesByQueryURL
 * method: getAvailableCoveringCertificatesByQuery_TYPE
 * raw_url: getAvailableCoveringCertificatesByQuery_RAW_URL
 * @param query - 
 */
export const getAvailableCoveringCertificatesByQuery = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-certificate/available-certificates'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['query'] !== undefined) {
    queryParameters['query'] = parameters['query']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAvailableCoveringCertificatesByQuery_RAW_URL = function() {
  return '/covering-certificate/available-certificates'
}
export const getAvailableCoveringCertificatesByQuery_TYPE = function() {
  return 'get'
}
export const getAvailableCoveringCertificatesByQueryURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-certificate/available-certificates'
  if (parameters['query'] !== undefined) {
    queryParameters['query'] = parameters['query']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get available agreement numbers for a mare
 * request: getAvailableAgreementNumbers
 * url: getAvailableAgreementNumbersURL
 * method: getAvailableAgreementNumbers_TYPE
 * raw_url: getAvailableAgreementNumbers_RAW_URL
 * @param mareId - 
 */
export const getAvailableAgreementNumbers = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-certificate/covering-result'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['mareId'] !== undefined) {
    queryParameters['mareId'] = parameters['mareId']
  }
  if (parameters['mareId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mareId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAvailableAgreementNumbers_RAW_URL = function() {
  return '/covering-certificate/covering-result'
}
export const getAvailableAgreementNumbers_TYPE = function() {
  return 'get'
}
export const getAvailableAgreementNumbersURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-certificate/covering-result'
  if (parameters['mareId'] !== undefined) {
    queryParameters['mareId'] = parameters['mareId']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all covering types
 * request: getAllCoveringTypesEnum
 * url: getAllCoveringTypesEnumURL
 * method: getAllCoveringTypesEnum_TYPE
 * raw_url: getAllCoveringTypesEnum_RAW_URL
 */
export const getAllCoveringTypesEnum = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-certificate/covering-types'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllCoveringTypesEnum_RAW_URL = function() {
  return '/covering-certificate/covering-types'
}
export const getAllCoveringTypesEnum_TYPE = function() {
  return 'get'
}
export const getAllCoveringTypesEnumURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-certificate/covering-types'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get covering types for a specific breed
 * request: getAllCoveringTypesEnumForBreed
 * url: getAllCoveringTypesEnumForBreedURL
 * method: getAllCoveringTypesEnumForBreed_TYPE
 * raw_url: getAllCoveringTypesEnumForBreed_RAW_URL
 */
export const getAllCoveringTypesEnumForBreed = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-certificate/covering-types-for-breed'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllCoveringTypesEnumForBreed_RAW_URL = function() {
  return '/covering-certificate/covering-types-for-breed'
}
export const getAllCoveringTypesEnumForBreed_TYPE = function() {
  return 'get'
}
export const getAllCoveringTypesEnumForBreedURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-certificate/covering-types-for-breed'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Create covering certificate for an external stallion
 * request: createCoveringCertificateForExternalStallion
 * url: createCoveringCertificateForExternalStallionURL
 * method: createCoveringCertificateForExternalStallion_TYPE
 * raw_url: createCoveringCertificateForExternalStallion_RAW_URL
 * @param mareId - 
 * @param body - 
 */
export const createCoveringCertificateForExternalStallion = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-certificate/external/{mareId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{mareId}', `${parameters['mareId']}`)
  if (parameters['mareId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mareId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createCoveringCertificateForExternalStallion_RAW_URL = function() {
  return '/covering-certificate/external/{mareId}'
}
export const createCoveringCertificateForExternalStallion_TYPE = function() {
  return 'post'
}
export const createCoveringCertificateForExternalStallionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-certificate/external/{mareId}'
  path = path.replace('{mareId}', `${parameters['mareId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search covering certificates for a mare
 * request: searchCoveringCertificateForMare
 * url: searchCoveringCertificateForMareURL
 * method: searchCoveringCertificateForMare_TYPE
 * raw_url: searchCoveringCertificateForMare_RAW_URL
 * @param mareId - 
 * @param body - 
 */
export const searchCoveringCertificateForMare = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-certificate/mare/{mareId}/search'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{mareId}', `${parameters['mareId']}`)
  if (parameters['mareId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mareId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchCoveringCertificateForMare_RAW_URL = function() {
  return '/covering-certificate/mare/{mareId}/search'
}
export const searchCoveringCertificateForMare_TYPE = function() {
  return 'post'
}
export const searchCoveringCertificateForMareURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-certificate/mare/{mareId}/search'
  path = path.replace('{mareId}', `${parameters['mareId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count covering certificates for a mare
 * request: searchCoveringCertificateForMareCount
 * url: searchCoveringCertificateForMareCountURL
 * method: searchCoveringCertificateForMareCount_TYPE
 * raw_url: searchCoveringCertificateForMareCount_RAW_URL
 * @param mareId - 
 * @param body - 
 */
export const searchCoveringCertificateForMareCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-certificate/mare/{mareId}/search/count'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{mareId}', `${parameters['mareId']}`)
  if (parameters['mareId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mareId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchCoveringCertificateForMareCount_RAW_URL = function() {
  return '/covering-certificate/mare/{mareId}/search/count'
}
export const searchCoveringCertificateForMareCount_TYPE = function() {
  return 'post'
}
export const searchCoveringCertificateForMareCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-certificate/mare/{mareId}/search/count'
  path = path.replace('{mareId}', `${parameters['mareId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search covering certificates for a stallion
 * request: searchCoveringCertificateForStallion
 * url: searchCoveringCertificateForStallionURL
 * method: searchCoveringCertificateForStallion_TYPE
 * raw_url: searchCoveringCertificateForStallion_RAW_URL
 * @param stallionId - 
 * @param body - 
 */
export const searchCoveringCertificateForStallion = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-certificate/stallion/{stallionId}/search'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{stallionId}', `${parameters['stallionId']}`)
  if (parameters['stallionId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: stallionId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchCoveringCertificateForStallion_RAW_URL = function() {
  return '/covering-certificate/stallion/{stallionId}/search'
}
export const searchCoveringCertificateForStallion_TYPE = function() {
  return 'post'
}
export const searchCoveringCertificateForStallionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-certificate/stallion/{stallionId}/search'
  path = path.replace('{stallionId}', `${parameters['stallionId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count covering certificates for a stallion
 * request: searchCoveringCertificateForStallionCount
 * url: searchCoveringCertificateForStallionCountURL
 * method: searchCoveringCertificateForStallionCount_TYPE
 * raw_url: searchCoveringCertificateForStallionCount_RAW_URL
 * @param stallionId - 
 * @param body - 
 */
export const searchCoveringCertificateForStallionCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-certificate/stallion/{stallionId}/search/count'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{stallionId}', `${parameters['stallionId']}`)
  if (parameters['stallionId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: stallionId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchCoveringCertificateForStallionCount_RAW_URL = function() {
  return '/covering-certificate/stallion/{stallionId}/search/count'
}
export const searchCoveringCertificateForStallionCount_TYPE = function() {
  return 'post'
}
export const searchCoveringCertificateForStallionCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-certificate/stallion/{stallionId}/search/count'
  path = path.replace('{stallionId}', `${parameters['stallionId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete a covering certificate
 * request: deleteCoveringCertificate
 * url: deleteCoveringCertificateURL
 * method: deleteCoveringCertificate_TYPE
 * raw_url: deleteCoveringCertificate_RAW_URL
 * @param id - 
 */
export const deleteCoveringCertificate = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-certificate/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteCoveringCertificate_RAW_URL = function() {
  return '/covering-certificate/{id}'
}
export const deleteCoveringCertificate_TYPE = function() {
  return 'delete'
}
export const deleteCoveringCertificateURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-certificate/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Create or update a covering result
 * request: createOrUpdateCoveringResult
 * url: createOrUpdateCoveringResultURL
 * method: createOrUpdateCoveringResult_TYPE
 * raw_url: createOrUpdateCoveringResult_RAW_URL
 * @param body - 
 */
export const createOrUpdateCoveringResult = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-results'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createOrUpdateCoveringResult_RAW_URL = function() {
  return '/covering-results'
}
export const createOrUpdateCoveringResult_TYPE = function() {
  return 'post'
}
export const createOrUpdateCoveringResultURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-results'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete a covering result
 * request: deleteCoveringResult
 * url: deleteCoveringResultURL
 * method: deleteCoveringResult_TYPE
 * raw_url: deleteCoveringResult_RAW_URL
 * @param id - 
 */
export const deleteCoveringResult = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-results/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteCoveringResult_RAW_URL = function() {
  return '/covering-results/{id}'
}
export const deleteCoveringResult_TYPE = function() {
  return 'delete'
}
export const deleteCoveringResultURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-results/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get covering result by ID
 * request: getCoveringResult
 * url: getCoveringResultURL
 * method: getCoveringResult_TYPE
 * raw_url: getCoveringResult_RAW_URL
 * @param id - 
 */
export const getCoveringResult = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/covering-results/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCoveringResult_RAW_URL = function() {
  return '/covering-results/{id}'
}
export const getCoveringResult_TYPE = function() {
  return 'get'
}
export const getCoveringResultURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/covering-results/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get registered horses count by city
 * request: getNumberOfRegisteredHorsesByCity
 * url: getNumberOfRegisteredHorsesByCityURL
 * method: getNumberOfRegisteredHorsesByCity_TYPE
 * raw_url: getNumberOfRegisteredHorsesByCity_RAW_URL
 */
export const getNumberOfRegisteredHorsesByCity = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/dashboard/city'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getNumberOfRegisteredHorsesByCity_RAW_URL = function() {
  return '/dashboard/city'
}
export const getNumberOfRegisteredHorsesByCity_TYPE = function() {
  return 'get'
}
export const getNumberOfRegisteredHorsesByCityURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/dashboard/city'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get average registered horses by days
 * request: getAverageRegisteredByDays
 * url: getAverageRegisteredByDaysURL
 * method: getAverageRegisteredByDays_TYPE
 * raw_url: getAverageRegisteredByDays_RAW_URL
 */
export const getAverageRegisteredByDays = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/dashboard/count/average-registered'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAverageRegisteredByDays_RAW_URL = function() {
  return '/dashboard/count/average-registered'
}
export const getAverageRegisteredByDays_TYPE = function() {
  return 'get'
}
export const getAverageRegisteredByDaysURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/dashboard/count/average-registered'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get total DNA analyses in progress
 * request: getTotalDNAAnalysisInProgress
 * url: getTotalDNAAnalysisInProgressURL
 * method: getTotalDNAAnalysisInProgress_TYPE
 * raw_url: getTotalDNAAnalysisInProgress_RAW_URL
 */
export const getTotalDNAAnalysisInProgress = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/dashboard/count/dna'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTotalDNAAnalysisInProgress_RAW_URL = function() {
  return '/dashboard/count/dna'
}
export const getTotalDNAAnalysisInProgress_TYPE = function() {
  return 'get'
}
export const getTotalDNAAnalysisInProgressURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/dashboard/count/dna'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get total registrations waiting for approval
 * request: getTotalRegistrationWaitingApprovals
 * url: getTotalRegistrationWaitingApprovalsURL
 * method: getTotalRegistrationWaitingApprovals_TYPE
 * raw_url: getTotalRegistrationWaitingApprovals_RAW_URL
 */
export const getTotalRegistrationWaitingApprovals = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/dashboard/count/in-progress'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTotalRegistrationWaitingApprovals_RAW_URL = function() {
  return '/dashboard/count/in-progress'
}
export const getTotalRegistrationWaitingApprovals_TYPE = function() {
  return 'get'
}
export const getTotalRegistrationWaitingApprovalsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/dashboard/count/in-progress'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get total passports ready for printing
 * request: getTotalPassportsReadyForPrinting
 * url: getTotalPassportsReadyForPrintingURL
 * method: getTotalPassportsReadyForPrinting_TYPE
 * raw_url: getTotalPassportsReadyForPrinting_RAW_URL
 */
export const getTotalPassportsReadyForPrinting = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/dashboard/count/passports'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTotalPassportsReadyForPrinting_RAW_URL = function() {
  return '/dashboard/count/passports'
}
export const getTotalPassportsReadyForPrinting_TYPE = function() {
  return 'get'
}
export const getTotalPassportsReadyForPrintingURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/dashboard/count/passports'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get exported horses by country and year
 * request: getExportedHorsesByCountryAndYear
 * url: getExportedHorsesByCountryAndYearURL
 * method: getExportedHorsesByCountryAndYear_TYPE
 * raw_url: getExportedHorsesByCountryAndYear_RAW_URL
 */
export const getExportedHorsesByCountryAndYear = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/dashboard/exported'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getExportedHorsesByCountryAndYear_RAW_URL = function() {
  return '/dashboard/exported'
}
export const getExportedHorsesByCountryAndYear_TYPE = function() {
  return 'get'
}
export const getExportedHorsesByCountryAndYearURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/dashboard/exported'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get number of registered foals
 * request: getNumberOfRegisteredFoals
 * url: getNumberOfRegisteredFoalsURL
 * method: getNumberOfRegisteredFoals_TYPE
 * raw_url: getNumberOfRegisteredFoals_RAW_URL
 */
export const getNumberOfRegisteredFoals = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/dashboard/foal'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getNumberOfRegisteredFoals_RAW_URL = function() {
  return '/dashboard/foal'
}
export const getNumberOfRegisteredFoals_TYPE = function() {
  return 'get'
}
export const getNumberOfRegisteredFoalsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/dashboard/foal'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get foal count by city and year
 * request: getNumberOfFoalByCityAndYear
 * url: getNumberOfFoalByCityAndYearURL
 * method: getNumberOfFoalByCityAndYear_TYPE
 * raw_url: getNumberOfFoalByCityAndYear_RAW_URL
 */
export const getNumberOfFoalByCityAndYear = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/dashboard/foal/city'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getNumberOfFoalByCityAndYear_RAW_URL = function() {
  return '/dashboard/foal/city'
}
export const getNumberOfFoalByCityAndYear_TYPE = function() {
  return 'get'
}
export const getNumberOfFoalByCityAndYearURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/dashboard/foal/city'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get registered horses count by gender
 * request: getNumberOfRegisteredHorsesByGender
 * url: getNumberOfRegisteredHorsesByGenderURL
 * method: getNumberOfRegisteredHorsesByGender_TYPE
 * raw_url: getNumberOfRegisteredHorsesByGender_RAW_URL
 */
export const getNumberOfRegisteredHorsesByGender = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/dashboard/gender'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getNumberOfRegisteredHorsesByGender_RAW_URL = function() {
  return '/dashboard/gender'
}
export const getNumberOfRegisteredHorsesByGender_TYPE = function() {
  return 'get'
}
export const getNumberOfRegisteredHorsesByGenderURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/dashboard/gender'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get imported horses by country and year
 * request: getImportedHorsesByCountryAndYear
 * url: getImportedHorsesByCountryAndYearURL
 * method: getImportedHorsesByCountryAndYear_TYPE
 * raw_url: getImportedHorsesByCountryAndYear_RAW_URL
 */
export const getImportedHorsesByCountryAndYear = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/dashboard/imported'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getImportedHorsesByCountryAndYear_RAW_URL = function() {
  return '/dashboard/imported'
}
export const getImportedHorsesByCountryAndYear_TYPE = function() {
  return 'get'
}
export const getImportedHorsesByCountryAndYearURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/dashboard/imported'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Create or update an event type
 * request: createOrUpdateEventType
 * url: createOrUpdateEventTypeURL
 * method: createOrUpdateEventType_TYPE
 * raw_url: createOrUpdateEventType_RAW_URL
 * @param body - 
 */
export const createOrUpdateEventType = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event-types'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createOrUpdateEventType_RAW_URL = function() {
  return '/event-types'
}
export const createOrUpdateEventType_TYPE = function() {
  return 'post'
}
export const createOrUpdateEventTypeURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event-types'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search event types
 * request: searchEventType
 * url: searchEventTypeURL
 * method: searchEventType_TYPE
 * raw_url: searchEventType_RAW_URL
 * @param body - 
 */
export const searchEventType = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event-types/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchEventType_RAW_URL = function() {
  return '/event-types/search'
}
export const searchEventType_TYPE = function() {
  return 'post'
}
export const searchEventTypeURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event-types/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count event types matching search criteria
 * request: searchEventTypeCount
 * url: searchEventTypeCountURL
 * method: searchEventTypeCount_TYPE
 * raw_url: searchEventTypeCount_RAW_URL
 * @param body - 
 */
export const searchEventTypeCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event-types/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchEventTypeCount_RAW_URL = function() {
  return '/event-types/search/count'
}
export const searchEventTypeCount_TYPE = function() {
  return 'post'
}
export const searchEventTypeCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event-types/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get selectable event types
 * request: getAllEventTypesToSelectValues
 * url: getAllEventTypesToSelectValuesURL
 * method: getAllEventTypesToSelectValues_TYPE
 * raw_url: getAllEventTypesToSelectValues_RAW_URL
 */
export const getAllEventTypesToSelectValues = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event-types/selectable'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllEventTypesToSelectValues_RAW_URL = function() {
  return '/event-types/selectable'
}
export const getAllEventTypesToSelectValues_TYPE = function() {
  return 'get'
}
export const getAllEventTypesToSelectValuesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event-types/selectable'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete an event type
 * request: deleteEventType
 * url: deleteEventTypeURL
 * method: deleteEventType_TYPE
 * raw_url: deleteEventType_RAW_URL
 * @param id - 
 */
export const deleteEventType = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event-types/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteEventType_RAW_URL = function() {
  return '/event-types/{id}'
}
export const deleteEventType_TYPE = function() {
  return 'delete'
}
export const deleteEventTypeURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event-types/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get an event type by ID
 * request: getEventType
 * url: getEventTypeURL
 * method: getEventType_TYPE
 * raw_url: getEventType_RAW_URL
 * @param id - 
 */
export const getEventType = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/event-types/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEventType_RAW_URL = function() {
  return '/event-types/{id}'
}
export const getEventType_TYPE = function() {
  return 'get'
}
export const getEventTypeURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/event-types/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all events for a horse
 * request: getEvents
 * url: getEventsURL
 * method: getEvents_TYPE
 * raw_url: getEvents_RAW_URL
 * @param horseId - 
 */
export const getEvents = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/events/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getEvents_RAW_URL = function() {
  return '/events/{horseId}'
}
export const getEvents_TYPE = function() {
  return 'get'
}
export const getEventsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/events/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Create a new event for a horse
 * request: createEvent
 * url: createEventURL
 * method: createEvent_TYPE
 * raw_url: createEvent_RAW_URL
 * @param horseId - 
 * @param body - 
 */
export const createEvent = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/events/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createEvent_RAW_URL = function() {
  return '/events/{horseId}'
}
export const createEvent_TYPE = function() {
  return 'post'
}
export const createEventURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/events/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get export document data for a horse
 * request: getExportData
 * url: getExportDataURL
 * method: getExportData_TYPE
 * raw_url: getExportData_RAW_URL
 * @param horseId - 
 */
export const getExportData = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/export-document/export-data/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getExportData_RAW_URL = function() {
  return '/export-document/export-data/{horseId}'
}
export const getExportData_TYPE = function() {
  return 'get'
}
export const getExportDataURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/export-document/export-data/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete files by IDs
 * request: deleteFile
 * url: deleteFileURL
 * method: deleteFile_TYPE
 * raw_url: deleteFile_RAW_URL
 * @param body - 
 */
export const deleteFile = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteFile_RAW_URL = function() {
  return '/files'
}
export const deleteFile_TYPE = function() {
  return 'delete'
}
export const deleteFileURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get attachments for a horse
 * request: getHorseAttachments
 * url: getHorseAttachmentsURL
 * method: getHorseAttachments_TYPE
 * raw_url: getHorseAttachments_RAW_URL
 * @param horseId - 
 */
export const getHorseAttachments = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/attachments/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseAttachments_RAW_URL = function() {
  return '/files/attachments/{horseId}'
}
export const getHorseAttachments_TYPE = function() {
  return 'get'
}
export const getHorseAttachmentsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/attachments/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Upload attachments for a horse
 * request: uploadAttachments
 * url: uploadAttachmentsURL
 * method: uploadAttachments_TYPE
 * raw_url: uploadAttachments_RAW_URL
 * @param horseId - 
 * @param body - 
 */
export const uploadAttachments = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/attachments/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadAttachments_RAW_URL = function() {
  return '/files/attachments/{horseId}'
}
export const uploadAttachments_TYPE = function() {
  return 'post'
}
export const uploadAttachmentsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/attachments/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete horse avatar
 * request: deleteHorseAvatar
 * url: deleteHorseAvatarURL
 * method: deleteHorseAvatar_TYPE
 * raw_url: deleteHorseAvatar_RAW_URL
 * @param horseId - 
 */
export const deleteHorseAvatar = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/avatar/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteHorseAvatar_RAW_URL = function() {
  return '/files/avatar/{horseId}'
}
export const deleteHorseAvatar_TYPE = function() {
  return 'delete'
}
export const deleteHorseAvatarURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/avatar/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse avatar
 * request: getHorseAvatar
 * url: getHorseAvatarURL
 * method: getHorseAvatar_TYPE
 * raw_url: getHorseAvatar_RAW_URL
 * @param horseId - 
 */
export const getHorseAvatar = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/avatar/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseAvatar_RAW_URL = function() {
  return '/files/avatar/{horseId}'
}
export const getHorseAvatar_TYPE = function() {
  return 'get'
}
export const getHorseAvatarURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/avatar/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete horse DNA card
 * request: deleteHorseDnaCard
 * url: deleteHorseDnaCardURL
 * method: deleteHorseDnaCard_TYPE
 * raw_url: deleteHorseDnaCard_RAW_URL
 * @param horseId - 
 */
export const deleteHorseDnaCard = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/dna-card/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteHorseDnaCard_RAW_URL = function() {
  return '/files/dna-card/{horseId}'
}
export const deleteHorseDnaCard_TYPE = function() {
  return 'delete'
}
export const deleteHorseDnaCardURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/dna-card/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse DNA card
 * request: getHorseDnaCard
 * url: getHorseDnaCardURL
 * method: getHorseDnaCard_TYPE
 * raw_url: getHorseDnaCard_RAW_URL
 * @param horseId - 
 */
export const getHorseDnaCard = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/dna-card/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseDnaCard_RAW_URL = function() {
  return '/files/dna-card/{horseId}'
}
export const getHorseDnaCard_TYPE = function() {
  return 'get'
}
export const getHorseDnaCardURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/dna-card/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Upload horse DNA card
 * request: setHorseDnaCard
 * url: setHorseDnaCardURL
 * method: setHorseDnaCard_TYPE
 * raw_url: setHorseDnaCard_RAW_URL
 * @param horseId - 
 * @param body - 
 */
export const setHorseDnaCard = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/dna-card/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const setHorseDnaCard_RAW_URL = function() {
  return '/files/dna-card/{horseId}'
}
export const setHorseDnaCard_TYPE = function() {
  return 'post'
}
export const setHorseDnaCardURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/dna-card/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get available document types
 * request: getDocumentTypes
 * url: getDocumentTypesURL
 * method: getDocumentTypes_TYPE
 * raw_url: getDocumentTypes_RAW_URL
 */
export const getDocumentTypes = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/document-types'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDocumentTypes_RAW_URL = function() {
  return '/files/document-types'
}
export const getDocumentTypes_TYPE = function() {
  return 'get'
}
export const getDocumentTypesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/document-types'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get documents for a horse
 * request: getHorseDocuments
 * url: getHorseDocumentsURL
 * method: getHorseDocuments_TYPE
 * raw_url: getHorseDocuments_RAW_URL
 * @param horseId - 
 */
export const getHorseDocuments = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/document/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseDocuments_RAW_URL = function() {
  return '/files/document/{horseId}'
}
export const getHorseDocuments_TYPE = function() {
  return 'get'
}
export const getHorseDocumentsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/document/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate a document for a horse
 * request: generateDocument
 * url: generateDocumentURL
 * method: generateDocument_TYPE
 * raw_url: generateDocument_RAW_URL
 * @param horseId - 
 * @param body - 
 */
export const generateDocument = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/document/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const generateDocument_RAW_URL = function() {
  return '/files/document/{horseId}'
}
export const generateDocument_TYPE = function() {
  return 'post'
}
export const generateDocumentURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/document/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete horse export certificate
 * request: deleteHorseExportCertificate
 * url: deleteHorseExportCertificateURL
 * method: deleteHorseExportCertificate_TYPE
 * raw_url: deleteHorseExportCertificate_RAW_URL
 * @param horseId - 
 */
export const deleteHorseExportCertificate = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/export-certificate/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteHorseExportCertificate_RAW_URL = function() {
  return '/files/export-certificate/{horseId}'
}
export const deleteHorseExportCertificate_TYPE = function() {
  return 'delete'
}
export const deleteHorseExportCertificateURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/export-certificate/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse export certificate
 * request: getHorseExportCertificate
 * url: getHorseExportCertificateURL
 * method: getHorseExportCertificate_TYPE
 * raw_url: getHorseExportCertificate_RAW_URL
 * @param horseId - 
 */
export const getHorseExportCertificate = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/export-certificate/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseExportCertificate_RAW_URL = function() {
  return '/files/export-certificate/{horseId}'
}
export const getHorseExportCertificate_TYPE = function() {
  return 'get'
}
export const getHorseExportCertificateURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/export-certificate/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Upload horse export certificate
 * request: setHorseExportCertificate
 * url: setHorseExportCertificateURL
 * method: setHorseExportCertificate_TYPE
 * raw_url: setHorseExportCertificate_RAW_URL
 * @param horseId - 
 * @param body - 
 */
export const setHorseExportCertificate = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/export-certificate/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const setHorseExportCertificate_RAW_URL = function() {
  return '/files/export-certificate/{horseId}'
}
export const setHorseExportCertificate_TYPE = function() {
  return 'post'
}
export const setHorseExportCertificateURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/export-certificate/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete horse passport file
 * request: deleteHorsePassport
 * url: deleteHorsePassportURL
 * method: deleteHorsePassport_TYPE
 * raw_url: deleteHorsePassport_RAW_URL
 * @param horseId - 
 */
export const deleteHorsePassport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/passport/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteHorsePassport_RAW_URL = function() {
  return '/files/passport/{horseId}'
}
export const deleteHorsePassport_TYPE = function() {
  return 'delete'
}
export const deleteHorsePassportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/passport/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse passport file
 * request: getHorsePassport
 * url: getHorsePassportURL
 * method: getHorsePassport_TYPE
 * raw_url: getHorsePassport_RAW_URL
 * @param horseId - 
 */
export const getHorsePassport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/passport/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorsePassport_RAW_URL = function() {
  return '/files/passport/{horseId}'
}
export const getHorsePassport_TYPE = function() {
  return 'get'
}
export const getHorsePassportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/passport/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Upload horse passport file
 * request: setHorsePassport
 * url: setHorsePassportURL
 * method: setHorsePassport_TYPE
 * raw_url: setHorsePassport_RAW_URL
 * @param horseId - 
 * @param body - 
 */
export const setHorsePassport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/passport/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const setHorsePassport_RAW_URL = function() {
  return '/files/passport/{horseId}'
}
export const setHorsePassport_TYPE = function() {
  return 'post'
}
export const setHorsePassportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/passport/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get photos for a horse
 * request: getHorsePhotos
 * url: getHorsePhotosURL
 * method: getHorsePhotos_TYPE
 * raw_url: getHorsePhotos_RAW_URL
 * @param horseId - 
 */
export const getHorsePhotos = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/photos/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorsePhotos_RAW_URL = function() {
  return '/files/photos/{horseId}'
}
export const getHorsePhotos_TYPE = function() {
  return 'get'
}
export const getHorsePhotosURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/photos/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Upload photos for a horse
 * request: uploadPhotos
 * url: uploadPhotosURL
 * method: uploadPhotos_TYPE
 * raw_url: uploadPhotos_RAW_URL
 * @param horseId - 
 * @param body - 
 */
export const uploadPhotos = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/photos/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const uploadPhotos_RAW_URL = function() {
  return '/files/photos/{horseId}'
}
export const uploadPhotos_TYPE = function() {
  return 'post'
}
export const uploadPhotosURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/photos/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search documents
 * request: searchDocument
 * url: searchDocumentURL
 * method: searchDocument_TYPE
 * raw_url: searchDocument_RAW_URL
 * @param body - 
 */
export const searchDocument = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchDocument_RAW_URL = function() {
  return '/files/search'
}
export const searchDocument_TYPE = function() {
  return 'post'
}
export const searchDocumentURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count documents matching search criteria
 * request: searchDocumentCount
 * url: searchDocumentCountURL
 * method: searchDocumentCount_TYPE
 * raw_url: searchDocumentCount_RAW_URL
 * @param body - 
 */
export const searchDocumentCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchDocumentCount_RAW_URL = function() {
  return '/files/search/count'
}
export const searchDocumentCount_TYPE = function() {
  return 'post'
}
export const searchDocumentCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Set horse avatar from existing photo
 * request: setHorseAvatar
 * url: setHorseAvatarURL
 * method: setHorseAvatar_TYPE
 * raw_url: setHorseAvatar_RAW_URL
 * @param horseId - 
 * @param photoId - 
 */
export const setHorseAvatar = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/set-avatar/{horseId}/{photoId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  path = path.replace('{photoId}', `${parameters['photoId']}`)
  if (parameters['photoId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: photoId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const setHorseAvatar_RAW_URL = function() {
  return '/files/set-avatar/{horseId}/{photoId}'
}
export const setHorseAvatar_TYPE = function() {
  return 'post'
}
export const setHorseAvatarURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/set-avatar/{horseId}/{photoId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  path = path.replace('{photoId}', `${parameters['photoId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Download a file by ID
 * request: getFile
 * url: getFileURL
 * method: getFile_TYPE
 * raw_url: getFile_RAW_URL
 * @param id - 
 */
export const getFile = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/files/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFile_RAW_URL = function() {
  return '/files/{id}'
}
export const getFile_TYPE = function() {
  return 'get'
}
export const getFileURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/files/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Create or update a forbidden name
 * request: createOrUpdateForbiddenName
 * url: createOrUpdateForbiddenNameURL
 * method: createOrUpdateForbiddenName_TYPE
 * raw_url: createOrUpdateForbiddenName_RAW_URL
 * @param body - 
 */
export const createOrUpdateForbiddenName = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/forbidden-name'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createOrUpdateForbiddenName_RAW_URL = function() {
  return '/forbidden-name'
}
export const createOrUpdateForbiddenName_TYPE = function() {
  return 'post'
}
export const createOrUpdateForbiddenNameURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/forbidden-name'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search forbidden names
 * request: searchForbiddenName
 * url: searchForbiddenNameURL
 * method: searchForbiddenName_TYPE
 * raw_url: searchForbiddenName_RAW_URL
 * @param body - 
 */
export const searchForbiddenName = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/forbidden-name/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchForbiddenName_RAW_URL = function() {
  return '/forbidden-name/search'
}
export const searchForbiddenName_TYPE = function() {
  return 'post'
}
export const searchForbiddenNameURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/forbidden-name/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count forbidden names matching search criteria
 * request: searchForbiddenNameCount
 * url: searchForbiddenNameCountURL
 * method: searchForbiddenNameCount_TYPE
 * raw_url: searchForbiddenNameCount_RAW_URL
 * @param body - 
 */
export const searchForbiddenNameCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/forbidden-name/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchForbiddenNameCount_RAW_URL = function() {
  return '/forbidden-name/search/count'
}
export const searchForbiddenNameCount_TYPE = function() {
  return 'post'
}
export const searchForbiddenNameCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/forbidden-name/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete a forbidden name
 * request: deleteForbiddenName
 * url: deleteForbiddenNameURL
 * method: deleteForbiddenName_TYPE
 * raw_url: deleteForbiddenName_RAW_URL
 * @param id - 
 */
export const deleteForbiddenName = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/forbidden-name/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteForbiddenName_RAW_URL = function() {
  return '/forbidden-name/{id}'
}
export const deleteForbiddenName_TYPE = function() {
  return 'delete'
}
export const deleteForbiddenNameURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/forbidden-name/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get a forbidden name by ID
 * request: getForbiddenName
 * url: getForbiddenNameURL
 * method: getForbiddenName_TYPE
 * raw_url: getForbiddenName_RAW_URL
 * @param id - 
 */
export const getForbiddenName = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/forbidden-name/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getForbiddenName_RAW_URL = function() {
  return '/forbidden-name/{id}'
}
export const getForbiddenName_TYPE = function() {
  return 'get'
}
export const getForbiddenNameURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/forbidden-name/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Export history log to CSV
 * request: exportHistoryLogToCsv
 * url: exportHistoryLogToCsvURL
 * method: exportHistoryLogToCsv_TYPE
 * raw_url: exportHistoryLogToCsv_RAW_URL
 * @param body - 
 */
export const exportHistoryLogToCsv = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/export/log/csv'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const exportHistoryLogToCsv_RAW_URL = function() {
  return '/history/export/log/csv'
}
export const exportHistoryLogToCsv_TYPE = function() {
  return 'post'
}
export const exportHistoryLogToCsvURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/export/log/csv'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all history action types
 * request: getAllHistoryType
 * url: getAllHistoryTypeURL
 * method: getAllHistoryType_TYPE
 * raw_url: getAllHistoryType_RAW_URL
 */
export const getAllHistoryType = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/history-type'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllHistoryType_RAW_URL = function() {
  return '/history/history-type'
}
export const getAllHistoryType_TYPE = function() {
  return 'get'
}
export const getAllHistoryTypeURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/history-type'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search history log entries
 * request: searchHistoryLog
 * url: searchHistoryLogURL
 * method: searchHistoryLog_TYPE
 * raw_url: searchHistoryLog_RAW_URL
 * @param body - 
 */
export const searchHistoryLog = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/search/log'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchHistoryLog_RAW_URL = function() {
  return '/history/search/log'
}
export const searchHistoryLog_TYPE = function() {
  return 'post'
}
export const searchHistoryLogURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/search/log'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count history log entries matching search criteria
 * request: searchHistoryLogCount
 * url: searchHistoryLogCountURL
 * method: searchHistoryLogCount_TYPE
 * raw_url: searchHistoryLogCount_RAW_URL
 * @param body - 
 */
export const searchHistoryLogCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/search/log/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchHistoryLogCount_RAW_URL = function() {
  return '/history/search/log/count'
}
export const searchHistoryLogCount_TYPE = function() {
  return 'post'
}
export const searchHistoryLogCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/search/log/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get audit trail for a horse
 * request: getAuditTrail
 * url: getAuditTrailURL
 * method: getAuditTrail_TYPE
 * raw_url: getAuditTrail_RAW_URL
 * @param id - 
 */
export const getAuditTrail = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/{id}/audit-trail'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAuditTrail_RAW_URL = function() {
  return '/history/{id}/audit-trail'
}
export const getAuditTrail_TYPE = function() {
  return 'get'
}
export const getAuditTrailURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/{id}/audit-trail'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse data at a specific revision
 * request: getRevision
 * url: getRevisionURL
 * method: getRevision_TYPE
 * raw_url: getRevision_RAW_URL
 * @param id - 
 * @param revision - 
 */
export const getRevision = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/{id}/audit-trail/{revision}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{revision}', `${parameters['revision']}`)
  if (parameters['revision'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: revision'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRevision_RAW_URL = function() {
  return '/history/{id}/audit-trail/{revision}'
}
export const getRevision_TYPE = function() {
  return 'get'
}
export const getRevisionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/{id}/audit-trail/{revision}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{revision}', `${parameters['revision']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get covering agreements audit trail for a stallion
 * request: getCoveringAgreementsAuditTrail
 * url: getCoveringAgreementsAuditTrailURL
 * method: getCoveringAgreementsAuditTrail_TYPE
 * raw_url: getCoveringAgreementsAuditTrail_RAW_URL
 * @param id - 
 */
export const getCoveringAgreementsAuditTrail = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/{id}/covering-agreements/audit-trail'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCoveringAgreementsAuditTrail_RAW_URL = function() {
  return '/history/{id}/covering-agreements/audit-trail'
}
export const getCoveringAgreementsAuditTrail_TYPE = function() {
  return 'get'
}
export const getCoveringAgreementsAuditTrailURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/{id}/covering-agreements/audit-trail'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get covering agreements at a specific revision
 * request: getCoveringAgreementsForRevision
 * url: getCoveringAgreementsForRevisionURL
 * method: getCoveringAgreementsForRevision_TYPE
 * raw_url: getCoveringAgreementsForRevision_RAW_URL
 * @param id - 
 * @param revision - 
 */
export const getCoveringAgreementsForRevision = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/{id}/covering-agreements/{revision}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{revision}', `${parameters['revision']}`)
  if (parameters['revision'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: revision'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCoveringAgreementsForRevision_RAW_URL = function() {
  return '/history/{id}/covering-agreements/{revision}'
}
export const getCoveringAgreementsForRevision_TYPE = function() {
  return 'get'
}
export const getCoveringAgreementsForRevisionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/{id}/covering-agreements/{revision}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{revision}', `${parameters['revision']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get covering certificates audit trail for a mare
 * request: getCoveringCertificatesAuditTrail
 * url: getCoveringCertificatesAuditTrailURL
 * method: getCoveringCertificatesAuditTrail_TYPE
 * raw_url: getCoveringCertificatesAuditTrail_RAW_URL
 * @param id - 
 */
export const getCoveringCertificatesAuditTrail = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/{id}/covering-certificates/audit-trail'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCoveringCertificatesAuditTrail_RAW_URL = function() {
  return '/history/{id}/covering-certificates/audit-trail'
}
export const getCoveringCertificatesAuditTrail_TYPE = function() {
  return 'get'
}
export const getCoveringCertificatesAuditTrailURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/{id}/covering-certificates/audit-trail'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get covering certificates at a specific revision
 * request: getCoveringCertificatesForRevision
 * url: getCoveringCertificatesForRevisionURL
 * method: getCoveringCertificatesForRevision_TYPE
 * raw_url: getCoveringCertificatesForRevision_RAW_URL
 * @param id - 
 * @param revision - 
 */
export const getCoveringCertificatesForRevision = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/{id}/covering-certificates/{revision}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{revision}', `${parameters['revision']}`)
  if (parameters['revision'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: revision'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCoveringCertificatesForRevision_RAW_URL = function() {
  return '/history/{id}/covering-certificates/{revision}'
}
export const getCoveringCertificatesForRevision_TYPE = function() {
  return 'get'
}
export const getCoveringCertificatesForRevisionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/{id}/covering-certificates/{revision}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{revision}', `${parameters['revision']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get laboratory test audit trail for a horse
 * request: getLaboratoryTestAuditTrail
 * url: getLaboratoryTestAuditTrailURL
 * method: getLaboratoryTestAuditTrail_TYPE
 * raw_url: getLaboratoryTestAuditTrail_RAW_URL
 * @param id - 
 */
export const getLaboratoryTestAuditTrail = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/{id}/laboratory-test/audit-trail'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getLaboratoryTestAuditTrail_RAW_URL = function() {
  return '/history/{id}/laboratory-test/audit-trail'
}
export const getLaboratoryTestAuditTrail_TYPE = function() {
  return 'get'
}
export const getLaboratoryTestAuditTrailURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/{id}/laboratory-test/audit-trail'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get laboratory tests at a specific revision
 * request: getLaboratoryTestsForRevision
 * url: getLaboratoryTestsForRevisionURL
 * method: getLaboratoryTestsForRevision_TYPE
 * raw_url: getLaboratoryTestsForRevision_RAW_URL
 * @param id - 
 * @param revision - 
 */
export const getLaboratoryTestsForRevision = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/history/{id}/laboratory-test/{revision}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  path = path.replace('{revision}', `${parameters['revision']}`)
  if (parameters['revision'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: revision'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getLaboratoryTestsForRevision_RAW_URL = function() {
  return '/history/{id}/laboratory-test/{revision}'
}
export const getLaboratoryTestsForRevision_TYPE = function() {
  return 'get'
}
export const getLaboratoryTestsForRevisionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/history/{id}/laboratory-test/{revision}'
  path = path.replace('{id}', `${parameters['id']}`)
  path = path.replace('{revision}', `${parameters['revision']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Create or update a horse color
 * request: createOrUpdateHorseColor
 * url: createOrUpdateHorseColorURL
 * method: createOrUpdateHorseColor_TYPE
 * raw_url: createOrUpdateHorseColor_RAW_URL
 * @param body - 
 */
export const createOrUpdateHorseColor = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horse-colors'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createOrUpdateHorseColor_RAW_URL = function() {
  return '/horse-colors'
}
export const createOrUpdateHorseColor_TYPE = function() {
  return 'post'
}
export const createOrUpdateHorseColorURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horse-colors'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all horse colors for breed
 * request: getAllHorseColors
 * url: getAllHorseColorsURL
 * method: getAllHorseColors_TYPE
 * raw_url: getAllHorseColors_RAW_URL
 */
export const getAllHorseColors = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horse-colors/all'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllHorseColors_RAW_URL = function() {
  return '/horse-colors/all'
}
export const getAllHorseColors_TYPE = function() {
  return 'get'
}
export const getAllHorseColorsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horse-colors/all'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search horse colors
 * request: searchHorseColor
 * url: searchHorseColorURL
 * method: searchHorseColor_TYPE
 * raw_url: searchHorseColor_RAW_URL
 * @param body - 
 */
export const searchHorseColor = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horse-colors/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchHorseColor_RAW_URL = function() {
  return '/horse-colors/search'
}
export const searchHorseColor_TYPE = function() {
  return 'post'
}
export const searchHorseColorURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horse-colors/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count horse colors matching search criteria
 * request: searchHorseColorCount
 * url: searchHorseColorCountURL
 * method: searchHorseColorCount_TYPE
 * raw_url: searchHorseColorCount_RAW_URL
 * @param body - 
 */
export const searchHorseColorCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horse-colors/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchHorseColorCount_RAW_URL = function() {
  return '/horse-colors/search/count'
}
export const searchHorseColorCount_TYPE = function() {
  return 'post'
}
export const searchHorseColorCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horse-colors/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete a horse color
 * request: deleteHorseColor
 * url: deleteHorseColorURL
 * method: deleteHorseColor_TYPE
 * raw_url: deleteHorseColor_RAW_URL
 * @param id - 
 */
export const deleteHorseColor = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horse-colors/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteHorseColor_RAW_URL = function() {
  return '/horse-colors/{id}'
}
export const deleteHorseColor_TYPE = function() {
  return 'delete'
}
export const deleteHorseColorURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horse-colors/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse color by ID
 * request: getHorseColor
 * url: getHorseColorURL
 * method: getHorseColor_TYPE
 * raw_url: getHorseColor_RAW_URL
 * @param id - 
 */
export const getHorseColor = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horse-colors/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseColor_RAW_URL = function() {
  return '/horse-colors/{id}'
}
export const getHorseColor_TYPE = function() {
  return 'get'
}
export const getHorseColorURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horse-colors/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search broodmares
 * request: searchBroodmares
 * url: searchBroodmaresURL
 * method: searchBroodmares_TYPE
 * raw_url: searchBroodmares_RAW_URL
 * @param body - 
 */
export const searchBroodmares = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/broodmares/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchBroodmares_RAW_URL = function() {
  return '/horses/broodmares/search'
}
export const searchBroodmares_TYPE = function() {
  return 'post'
}
export const searchBroodmaresURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/broodmares/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count broodmares matching search criteria
 * request: searchBroodmaresCount
 * url: searchBroodmaresCountURL
 * method: searchBroodmaresCount_TYPE
 * raw_url: searchBroodmaresCount_RAW_URL
 * @param body - 
 */
export const searchBroodmaresCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/broodmares/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchBroodmaresCount_RAW_URL = function() {
  return '/horses/broodmares/search/count'
}
export const searchBroodmaresCount_TYPE = function() {
  return 'post'
}
export const searchBroodmaresCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/broodmares/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get a horse by UUID
 * request: getHorseByUUID
 * url: getHorseByUUIDURL
 * method: getHorseByUUID_TYPE
 * raw_url: getHorseByUUID_RAW_URL
 * @param uuid - 
 */
export const getHorseByUUID = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/by-uuid/{uuid}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{uuid}', `${parameters['uuid']}`)
  if (parameters['uuid'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: uuid'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseByUUID_RAW_URL = function() {
  return '/horses/by-uuid/{uuid}'
}
export const getHorseByUUID_TYPE = function() {
  return 'get'
}
export const getHorseByUUIDURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/by-uuid/{uuid}'
  path = path.replace('{uuid}', `${parameters['uuid']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get covering result type options
 * request: getCoveringResultTypesEnum
 * url: getCoveringResultTypesEnumURL
 * method: getCoveringResultTypesEnum_TYPE
 * raw_url: getCoveringResultTypesEnum_RAW_URL
 */
export const getCoveringResultTypesEnum = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/covering-result-types'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getCoveringResultTypesEnum_RAW_URL = function() {
  return '/horses/covering-result-types'
}
export const getCoveringResultTypesEnum_TYPE = function() {
  return 'get'
}
export const getCoveringResultTypesEnumURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/covering-result-types'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get DNA sample type options
 * request: getHorseDnaSampleTypes
 * url: getHorseDnaSampleTypesURL
 * method: getHorseDnaSampleTypes_TYPE
 * raw_url: getHorseDnaSampleTypes_RAW_URL
 */
export const getHorseDnaSampleTypes = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/dna-sample-type'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseDnaSampleTypes_RAW_URL = function() {
  return '/horses/dna-sample-type'
}
export const getHorseDnaSampleTypes_TYPE = function() {
  return 'get'
}
export const getHorseDnaSampleTypesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/dna-sample-type'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Edit a horse
 * request: editHorse
 * url: editHorseURL
 * method: editHorse_TYPE
 * raw_url: editHorse_RAW_URL
 * @param body - 
 */
export const editHorse = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/edit'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const editHorse_RAW_URL = function() {
  return '/horses/edit'
}
export const editHorse_TYPE = function() {
  return 'post'
}
export const editHorseURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/edit'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse data for editing
 * request: getHorseEdit
 * url: getHorseEditURL
 * method: getHorseEdit_TYPE
 * raw_url: getHorseEdit_RAW_URL
 * @param id - 
 */
export const getHorseEdit = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/edit/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseEdit_RAW_URL = function() {
  return '/horses/edit/{id}'
}
export const getHorseEdit_TYPE = function() {
  return 'get'
}
export const getHorseEditURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/edit/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Add an external horse for pedigree
 * request: addExternalHorse
 * url: addExternalHorseURL
 * method: addExternalHorse_TYPE
 * raw_url: addExternalHorse_RAW_URL
 * @param body - 
 */
export const addExternalHorse = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/external/add'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addExternalHorse_RAW_URL = function() {
  return '/horses/external/add'
}
export const addExternalHorse_TYPE = function() {
  return 'post'
}
export const addExternalHorseURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/external/add'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Save a foal draft
 * request: saveFoal
 * url: saveFoalURL
 * method: saveFoal_TYPE
 * raw_url: saveFoal_RAW_URL
 * @param body - 
 */
export const saveFoal = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/foal/save'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const saveFoal_RAW_URL = function() {
  return '/horses/foal/save'
}
export const saveFoal_TYPE = function() {
  return 'post'
}
export const saveFoalURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/foal/save'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Submit a foal for registration
 * request: submitFoal
 * url: submitFoalURL
 * method: submitFoal_TYPE
 * raw_url: submitFoal_RAW_URL
 * @param body - 
 */
export const submitFoal = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/foal/submit'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const submitFoal_RAW_URL = function() {
  return '/horses/foal/submit'
}
export const submitFoal_TYPE = function() {
  return 'post'
}
export const submitFoalURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/foal/submit'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get a foal by ID
 * request: getFoal
 * url: getFoalURL
 * method: getFoal_TYPE
 * raw_url: getFoal_RAW_URL
 * @param id - 
 */
export const getFoal = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/foal/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFoal_RAW_URL = function() {
  return '/horses/foal/{id}'
}
export const getFoal_TYPE = function() {
  return 'get'
}
export const getFoalURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/foal/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Reject a foal registration
 * request: rejectFoal
 * url: rejectFoalURL
 * method: rejectFoal_TYPE
 * raw_url: rejectFoal_RAW_URL
 * @param id - 
 */
export const rejectFoal = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/foal/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const rejectFoal_RAW_URL = function() {
  return '/horses/foal/{id}'
}
export const rejectFoal_TYPE = function() {
  return 'put'
}
export const rejectFoalURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/foal/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse breed options
 * request: getHorseBreedList
 * url: getHorseBreedListURL
 * method: getHorseBreedList_TYPE
 * raw_url: getHorseBreedList_RAW_URL
 */
export const getHorseBreedList = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/horse-breed'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseBreedList_RAW_URL = function() {
  return '/horses/horse-breed'
}
export const getHorseBreedList_TYPE = function() {
  return 'get'
}
export const getHorseBreedListURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/horse-breed'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse classification options
 * request: getHorseClassificationList
 * url: getHorseClassificationListURL
 * method: getHorseClassificationList_TYPE
 * raw_url: getHorseClassificationList_RAW_URL
 */
export const getHorseClassificationList = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/horse-classification'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseClassificationList_RAW_URL = function() {
  return '/horses/horse-classification'
}
export const getHorseClassificationList_TYPE = function() {
  return 'get'
}
export const getHorseClassificationListURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/horse-classification'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse sex options
 * request: getHorseSexList
 * url: getHorseSexListURL
 * method: getHorseSexList_TYPE
 * raw_url: getHorseSexList_RAW_URL
 */
export const getHorseSexList = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/horse-sex'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseSexList_RAW_URL = function() {
  return '/horses/horse-sex'
}
export const getHorseSexList_TYPE = function() {
  return 'get'
}
export const getHorseSexListURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/horse-sex'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse status options
 * request: getHorseStatusList
 * url: getHorseStatusListURL
 * method: getHorseStatusList_TYPE
 * raw_url: getHorseStatusList_RAW_URL
 */
export const getHorseStatusList = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/horse-status'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseStatusList_RAW_URL = function() {
  return '/horses/horse-status'
}
export const getHorseStatusList_TYPE = function() {
  return 'get'
}
export const getHorseStatusListURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/horse-status'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Save an imported horse draft
 * request: saveImportedHorse
 * url: saveImportedHorseURL
 * method: saveImportedHorse_TYPE
 * raw_url: saveImportedHorse_RAW_URL
 * @param body - 
 */
export const saveImportedHorse = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/imported/save'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const saveImportedHorse_RAW_URL = function() {
  return '/horses/imported/save'
}
export const saveImportedHorse_TYPE = function() {
  return 'post'
}
export const saveImportedHorseURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/imported/save'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Submit an imported horse for registration
 * request: submitImportedHorse
 * url: submitImportedHorseURL
 * method: submitImportedHorse_TYPE
 * raw_url: submitImportedHorse_RAW_URL
 * @param body - 
 */
export const submitImportedHorse = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/imported/submit'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const submitImportedHorse_RAW_URL = function() {
  return '/horses/imported/submit'
}
export const submitImportedHorse_TYPE = function() {
  return 'post'
}
export const submitImportedHorseURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/imported/submit'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get an imported horse by ID
 * request: getImportedHorse
 * url: getImportedHorseURL
 * method: getImportedHorse_TYPE
 * raw_url: getImportedHorse_RAW_URL
 * @param id - 
 */
export const getImportedHorse = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/imported/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getImportedHorse_RAW_URL = function() {
  return '/horses/imported/{id}'
}
export const getImportedHorse_TYPE = function() {
  return 'get'
}
export const getImportedHorseURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/imported/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search horses waiting for laboratory data
 * request: searchHorsesWaitingForLaboratoryData
 * url: searchHorsesWaitingForLaboratoryDataURL
 * method: searchHorsesWaitingForLaboratoryData_TYPE
 * raw_url: searchHorsesWaitingForLaboratoryData_RAW_URL
 * @param body - 
 */
export const searchHorsesWaitingForLaboratoryData = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/laboratory/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchHorsesWaitingForLaboratoryData_RAW_URL = function() {
  return '/horses/laboratory/search'
}
export const searchHorsesWaitingForLaboratoryData_TYPE = function() {
  return 'post'
}
export const searchHorsesWaitingForLaboratoryDataURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/laboratory/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count horses waiting for laboratory data
 * request: searchHorsesWaitingForLaboratoryDataCount
 * url: searchHorsesWaitingForLaboratoryDataCountURL
 * method: searchHorsesWaitingForLaboratoryDataCount_TYPE
 * raw_url: searchHorsesWaitingForLaboratoryDataCount_RAW_URL
 * @param body - 
 */
export const searchHorsesWaitingForLaboratoryDataCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/laboratory/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchHorsesWaitingForLaboratoryDataCount_RAW_URL = function() {
  return '/horses/laboratory/search/count'
}
export const searchHorsesWaitingForLaboratoryDataCount_TYPE = function() {
  return 'post'
}
export const searchHorsesWaitingForLaboratoryDataCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/laboratory/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search horse offspring
 * request: searchHorseOffspring
 * url: searchHorseOffspringURL
 * method: searchHorseOffspring_TYPE
 * raw_url: searchHorseOffspring_RAW_URL
 * @param body - 
 */
export const searchHorseOffspring = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/offspring/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchHorseOffspring_RAW_URL = function() {
  return '/horses/offspring/search'
}
export const searchHorseOffspring_TYPE = function() {
  return 'post'
}
export const searchHorseOffspringURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/offspring/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count horse offspring matching search criteria
 * request: searchHorseOffspringCount
 * url: searchHorseOffspringCountURL
 * method: searchHorseOffspringCount_TYPE
 * raw_url: searchHorseOffspringCount_RAW_URL
 * @param body - 
 */
export const searchHorseOffspringCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/offspring/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchHorseOffspringCount_RAW_URL = function() {
  return '/horses/offspring/search/count'
}
export const searchHorseOffspringCount_TYPE = function() {
  return 'post'
}
export const searchHorseOffspringCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/offspring/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse origin options
 * request: getHorseOrigin
 * url: getHorseOriginURL
 * method: getHorseOrigin_TYPE
 * raw_url: getHorseOrigin_RAW_URL
 */
export const getHorseOrigin = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/origin'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseOrigin_RAW_URL = function() {
  return '/horses/origin'
}
export const getHorseOrigin_TYPE = function() {
  return 'get'
}
export const getHorseOriginURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/origin'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count pending horses per user role
 * request: searchPendingHorsesPerUserRoleCount
 * url: searchPendingHorsesPerUserRoleCountURL
 * method: searchPendingHorsesPerUserRoleCount_TYPE
 * raw_url: searchPendingHorsesPerUserRoleCount_RAW_URL
 * @param body - 
 */
export const searchPendingHorsesPerUserRoleCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/pending/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchPendingHorsesPerUserRoleCount_RAW_URL = function() {
  return '/horses/pending/count'
}
export const searchPendingHorsesPerUserRoleCount_TYPE = function() {
  return 'post'
}
export const searchPendingHorsesPerUserRoleCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/pending/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search pending horses per user role
 * request: searchPendingHorsesPerUserRole
 * url: searchPendingHorsesPerUserRoleURL
 * method: searchPendingHorsesPerUserRole_TYPE
 * raw_url: searchPendingHorsesPerUserRole_RAW_URL
 * @param body - 
 */
export const searchPendingHorsesPerUserRole = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/pending/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchPendingHorsesPerUserRole_RAW_URL = function() {
  return '/horses/pending/search'
}
export const searchPendingHorsesPerUserRole_TYPE = function() {
  return 'post'
}
export const searchPendingHorsesPerUserRoleURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/pending/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate register ID and UELN for imported horses
 * request: generateRegisterIdAndUelnForImportedHorses
 * url: generateRegisterIdAndUelnForImportedHorsesURL
 * method: generateRegisterIdAndUelnForImportedHorses_TYPE
 * raw_url: generateRegisterIdAndUelnForImportedHorses_RAW_URL
 */
export const generateRegisterIdAndUelnForImportedHorses = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/register-id-and-ueln-for-imported-horses/generate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const generateRegisterIdAndUelnForImportedHorses_RAW_URL = function() {
  return '/horses/register-id-and-ueln-for-imported-horses/generate'
}
export const generateRegisterIdAndUelnForImportedHorses_TYPE = function() {
  return 'post'
}
export const generateRegisterIdAndUelnForImportedHorsesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/register-id-and-ueln-for-imported-horses/generate'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search horses
 * request: searchHorse
 * url: searchHorseURL
 * method: searchHorse_TYPE
 * raw_url: searchHorse_RAW_URL
 * @param body - 
 */
export const searchHorse = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchHorse_RAW_URL = function() {
  return '/horses/search'
}
export const searchHorse_TYPE = function() {
  return 'post'
}
export const searchHorseURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search for similar horses
 * request: searchSimpleHorse
 * url: searchSimpleHorseURL
 * method: searchSimpleHorse_TYPE
 * raw_url: searchSimpleHorse_RAW_URL
 * @param body - 
 */
export const searchSimpleHorse = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/search-similar'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchSimpleHorse_RAW_URL = function() {
  return '/horses/search-similar'
}
export const searchSimpleHorse_TYPE = function() {
  return 'post'
}
export const searchSimpleHorseURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/search-similar'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count horses matching search criteria
 * request: searchHorseCount
 * url: searchHorseCountURL
 * method: searchHorseCount_TYPE
 * raw_url: searchHorseCount_RAW_URL
 * @param body - 
 */
export const searchHorseCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchHorseCount_RAW_URL = function() {
  return '/horses/search/count'
}
export const searchHorseCount_TYPE = function() {
  return 'post'
}
export const searchHorseCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search horses for pedigree selection
 * request: searchHorseForPedigree
 * url: searchHorseForPedigreeURL
 * method: searchHorseForPedigree_TYPE
 * raw_url: searchHorseForPedigree_RAW_URL
 * @param query - 
 * @param horseParentsType - 
 */
export const searchHorseForPedigree = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/search/pedigree'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['query'] !== undefined) {
    queryParameters['query'] = parameters['query']
  }
  if (parameters['query'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: query'))
  }
  if (parameters['horseParentsType'] !== undefined) {
    queryParameters['horseParentsType'] = parameters['horseParentsType']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const searchHorseForPedigree_RAW_URL = function() {
  return '/horses/search/pedigree'
}
export const searchHorseForPedigree_TYPE = function() {
  return 'get'
}
export const searchHorseForPedigreeURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/search/pedigree'
  if (parameters['query'] !== undefined) {
    queryParameters['query'] = parameters['query']
  }
  if (parameters['horseParentsType'] !== undefined) {
    queryParameters['horseParentsType'] = parameters['horseParentsType']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get semen origin options
 * request: getSemenOriginEnum
 * url: getSemenOriginEnumURL
 * method: getSemenOriginEnum_TYPE
 * raw_url: getSemenOriginEnum_RAW_URL
 */
export const getSemenOriginEnum = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/semen-origin'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSemenOriginEnum_RAW_URL = function() {
  return '/horses/semen-origin'
}
export const getSemenOriginEnum_TYPE = function() {
  return 'get'
}
export const getSemenOriginEnumURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/semen-origin'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get semen type options
 * request: getSemenTypesEnum
 * url: getSemenTypesEnumURL
 * method: getSemenTypesEnum_TYPE
 * raw_url: getSemenTypesEnum_RAW_URL
 */
export const getSemenTypesEnum = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/semen-types'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSemenTypesEnum_RAW_URL = function() {
  return '/horses/semen-types'
}
export const getSemenTypesEnum_TYPE = function() {
  return 'get'
}
export const getSemenTypesEnumURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/semen-types'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search stallions
 * request: searchStallions
 * url: searchStallionsURL
 * method: searchStallions_TYPE
 * raw_url: searchStallions_RAW_URL
 * @param body - 
 */
export const searchStallions = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/stallions/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchStallions_RAW_URL = function() {
  return '/horses/stallions/search'
}
export const searchStallions_TYPE = function() {
  return 'post'
}
export const searchStallionsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/stallions/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count stallions matching search criteria
 * request: searchStallionsCount
 * url: searchStallionsCountURL
 * method: searchStallionsCount_TYPE
 * raw_url: searchStallionsCount_RAW_URL
 * @param body - 
 */
export const searchStallionsCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/stallions/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchStallionsCount_RAW_URL = function() {
  return '/horses/stallions/search/count'
}
export const searchStallionsCount_TYPE = function() {
  return 'post'
}
export const searchStallionsCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/stallions/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse history view
 * request: getHorseHistoryView
 * url: getHorseHistoryViewURL
 * method: getHorseHistoryView_TYPE
 * raw_url: getHorseHistoryView_RAW_URL
 * @param id - 
 */
export const getHorseHistoryView = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/view-history/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseHistoryView_RAW_URL = function() {
  return '/horses/view-history/{id}'
}
export const getHorseHistoryView_TYPE = function() {
  return 'get'
}
export const getHorseHistoryViewURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/view-history/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse view details
 * request: getHorseView
 * url: getHorseViewURL
 * method: getHorseView_TYPE
 * raw_url: getHorseView_RAW_URL
 * @param id - 
 */
export const getHorseView = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/view/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseView_RAW_URL = function() {
  return '/horses/view/{id}'
}
export const getHorseView_TYPE = function() {
  return 'get'
}
export const getHorseViewURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/view/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get horse view for laboratory user
 * request: getHorseViewForLaboratoryUser
 * url: getHorseViewForLaboratoryUserURL
 * method: getHorseViewForLaboratoryUser_TYPE
 * raw_url: getHorseViewForLaboratoryUser_RAW_URL
 * @param id - 
 */
export const getHorseViewForLaboratoryUser = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/view/{id}/lab'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseViewForLaboratoryUser_RAW_URL = function() {
  return '/horses/view/{id}/lab'
}
export const getHorseViewForLaboratoryUser_TYPE = function() {
  return 'get'
}
export const getHorseViewForLaboratoryUserURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/view/{id}/lab'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete a horse
 * request: deleteHorse
 * url: deleteHorseURL
 * method: deleteHorse_TYPE
 * raw_url: deleteHorse_RAW_URL
 * @param id - 
 */
export const deleteHorse = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteHorse_RAW_URL = function() {
  return '/horses/{id}'
}
export const deleteHorse_TYPE = function() {
  return 'delete'
}
export const deleteHorseURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get a horse by ID
 * request: getHorse
 * url: getHorseURL
 * method: getHorse_TYPE
 * raw_url: getHorse_RAW_URL
 * @param id - 
 */
export const getHorse = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/horses/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorse_RAW_URL = function() {
  return '/horses/{id}'
}
export const getHorse_TYPE = function() {
  return 'get'
}
export const getHorseURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/horses/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Import external horses from file
 * request: importExternalHorses
 * url: importExternalHorsesURL
 * method: importExternalHorses_TYPE
 * raw_url: importExternalHorses_RAW_URL
 * @param body - 
 */
export const importExternalHorses = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/import/external'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const importExternalHorses_RAW_URL = function() {
  return '/import/external'
}
export const importExternalHorses_TYPE = function() {
  return 'post'
}
export const importExternalHorsesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/import/external'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Import local horses from file
 * request: importLocalHorses
 * url: importLocalHorsesURL
 * method: importLocalHorses_TYPE
 * raw_url: importLocalHorses_RAW_URL
 * @param body - 
 */
export const importLocalHorses = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/import/local'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const importLocalHorses_RAW_URL = function() {
  return '/import/local'
}
export const importLocalHorses_TYPE = function() {
  return 'post'
}
export const importLocalHorsesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/import/local'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Check if current access token is valid
 * request: isTokenValid
 * url: isTokenValidURL
 * method: isTokenValid_TYPE
 * raw_url: isTokenValid_RAW_URL
 */
export const isTokenValid = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/is-token-valid'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const isTokenValid_RAW_URL = function() {
  return '/is-token-valid'
}
export const isTokenValid_TYPE = function() {
  return 'get'
}
export const isTokenValidURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/is-token-valid'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Submit laboratory test result
 * request: fillHorseTest
 * url: fillHorseTestURL
 * method: fillHorseTest_TYPE
 * raw_url: fillHorseTest_RAW_URL
 * @param body - 
 */
export const fillHorseTest = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/lab/fill-test'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const fillHorseTest_RAW_URL = function() {
  return '/lab/fill-test'
}
export const fillHorseTest_TYPE = function() {
  return 'post'
}
export const fillHorseTestURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/lab/fill-test'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get laboratory tests for a horse
 * request: getHorseTests
 * url: getHorseTestsURL
 * method: getHorseTests_TYPE
 * raw_url: getHorseTests_RAW_URL
 * @param horseId - 
 */
export const getHorseTests = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/lab/horse-tests/{horseId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters['horseId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: horseId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHorseTests_RAW_URL = function() {
  return '/lab/horse-tests/{horseId}'
}
export const getHorseTests_TYPE = function() {
  return 'get'
}
export const getHorseTestsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/lab/horse-tests/{horseId}'
  path = path.replace('{horseId}', `${parameters['horseId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get test priority options
 * request: getTestPriority
 * url: getTestPriorityURL
 * method: getTestPriority_TYPE
 * raw_url: getTestPriority_RAW_URL
 */
export const getTestPriority = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/lab/test-priority'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTestPriority_RAW_URL = function() {
  return '/lab/test-priority'
}
export const getTestPriority_TYPE = function() {
  return 'get'
}
export const getTestPriorityURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/lab/test-priority'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all laboratory test results
 * request: getTestResults
 * url: getTestResultsURL
 * method: getTestResults_TYPE
 * raw_url: getTestResults_RAW_URL
 */
export const getTestResults = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/lab/test-result'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTestResults_RAW_URL = function() {
  return '/lab/test-result'
}
export const getTestResults_TYPE = function() {
  return 'get'
}
export const getTestResultsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/lab/test-result'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all laboratory test statuses
 * request: getTestStatuses
 * url: getTestStatusesURL
 * method: getTestStatuses_TYPE
 * raw_url: getTestStatuses_RAW_URL
 */
export const getTestStatuses = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/lab/test-status'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTestStatuses_RAW_URL = function() {
  return '/lab/test-status'
}
export const getTestStatuses_TYPE = function() {
  return 'get'
}
export const getTestStatusesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/lab/test-status'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get test type options
 * request: getTestType
 * url: getTestTypeURL
 * method: getTestType_TYPE
 * raw_url: getTestType_RAW_URL
 */
export const getTestType = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/lab/test-type'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTestType_RAW_URL = function() {
  return '/lab/test-type'
}
export const getTestType_TYPE = function() {
  return 'get'
}
export const getTestTypeURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/lab/test-type'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all laboratories
 * request: getAllLaboratories
 * url: getAllLaboratoriesURL
 * method: getAllLaboratories_TYPE
 * raw_url: getAllLaboratories_RAW_URL
 */
export const getAllLaboratories = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/laboratories'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllLaboratories_RAW_URL = function() {
  return '/laboratories'
}
export const getAllLaboratories_TYPE = function() {
  return 'get'
}
export const getAllLaboratoriesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/laboratories'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Create or update a laboratory
 * request: createOrUpdateLaboratory
 * url: createOrUpdateLaboratoryURL
 * method: createOrUpdateLaboratory_TYPE
 * raw_url: createOrUpdateLaboratory_RAW_URL
 * @param body - 
 */
export const createOrUpdateLaboratory = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/laboratories'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createOrUpdateLaboratory_RAW_URL = function() {
  return '/laboratories'
}
export const createOrUpdateLaboratory_TYPE = function() {
  return 'post'
}
export const createOrUpdateLaboratoryURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/laboratories'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search laboratories
 * request: searchLaboratory
 * url: searchLaboratoryURL
 * method: searchLaboratory_TYPE
 * raw_url: searchLaboratory_RAW_URL
 * @param body - 
 */
export const searchLaboratory = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/laboratories/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchLaboratory_RAW_URL = function() {
  return '/laboratories/search'
}
export const searchLaboratory_TYPE = function() {
  return 'post'
}
export const searchLaboratoryURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/laboratories/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count laboratories matching search criteria
 * request: searchLaboratoryCount
 * url: searchLaboratoryCountURL
 * method: searchLaboratoryCount_TYPE
 * raw_url: searchLaboratoryCount_RAW_URL
 * @param body - 
 */
export const searchLaboratoryCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/laboratories/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchLaboratoryCount_RAW_URL = function() {
  return '/laboratories/search/count'
}
export const searchLaboratoryCount_TYPE = function() {
  return 'post'
}
export const searchLaboratoryCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/laboratories/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete a laboratory
 * request: deleteLaboratory
 * url: deleteLaboratoryURL
 * method: deleteLaboratory_TYPE
 * raw_url: deleteLaboratory_RAW_URL
 * @param id - 
 */
export const deleteLaboratory = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/laboratories/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteLaboratory_RAW_URL = function() {
  return '/laboratories/{id}'
}
export const deleteLaboratory_TYPE = function() {
  return 'delete'
}
export const deleteLaboratoryURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/laboratories/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get laboratory by ID
 * request: getLaboratory
 * url: getLaboratoryURL
 * method: getLaboratory_TYPE
 * raw_url: getLaboratory_RAW_URL
 * @param id - 
 */
export const getLaboratory = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/laboratories/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getLaboratory_RAW_URL = function() {
  return '/laboratories/{id}'
}
export const getLaboratory_TYPE = function() {
  return 'get'
}
export const getLaboratoryURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/laboratories/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Authenticate user and obtain access token
 * request: login
 * url: loginURL
 * method: login_TYPE
 * raw_url: login_RAW_URL
 * @param body - 
 */
export const login = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/login'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const login_RAW_URL = function() {
  return '/login'
}
export const login_TYPE = function() {
  return 'post'
}
export const loginURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/login'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Logout and invalidate tokens
 * request: logout
 * url: logoutURL
 * method: logout_TYPE
 * raw_url: logout_RAW_URL
 */
export const logout = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/logout'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const logout_RAW_URL = function() {
  return '/logout'
}
export const logout_TYPE = function() {
  return 'post'
}
export const logoutURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/logout'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get face whorl options
 * request: getFaceWhorls
 * url: getFaceWhorlsURL
 * method: getFaceWhorls_TYPE
 * raw_url: getFaceWhorls_RAW_URL
 */
export const getFaceWhorls = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/marking-data/face-whorl'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFaceWhorls_RAW_URL = function() {
  return '/marking-data/face-whorl'
}
export const getFaceWhorls_TYPE = function() {
  return 'get'
}
export const getFaceWhorlsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/marking-data/face-whorl'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get hoof options
 * request: getHoofTypes
 * url: getHoofTypesURL
 * method: getHoofTypes_TYPE
 * raw_url: getHoofTypes_RAW_URL
 */
export const getHoofTypes = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/marking-data/hoof'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getHoofTypes_RAW_URL = function() {
  return '/marking-data/hoof'
}
export const getHoofTypes_TYPE = function() {
  return 'get'
}
export const getHoofTypesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/marking-data/hoof'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get mark position options
 * request: getMarkPositions
 * url: getMarkPositionsURL
 * method: getMarkPositions_TYPE
 * raw_url: getMarkPositions_RAW_URL
 */
export const getMarkPositions = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/marking-data/mark-position'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMarkPositions_RAW_URL = function() {
  return '/marking-data/mark-position'
}
export const getMarkPositions_TYPE = function() {
  return 'get'
}
export const getMarkPositionsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/marking-data/mark-position'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get mark type options
 * request: getMarkTypes
 * url: getMarkTypesURL
 * method: getMarkTypes_TYPE
 * raw_url: getMarkTypes_RAW_URL
 */
export const getMarkTypes = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/marking-data/mark-type'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getMarkTypes_RAW_URL = function() {
  return '/marking-data/mark-type'
}
export const getMarkTypes_TYPE = function() {
  return 'get'
}
export const getMarkTypesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/marking-data/mark-type'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get snip and flesh mark options
 * request: getSnipAndFleshMarks
 * url: getSnipAndFleshMarksURL
 * method: getSnipAndFleshMarks_TYPE
 * raw_url: getSnipAndFleshMarks_RAW_URL
 */
export const getSnipAndFleshMarks = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/marking-data/snip-flesh-mark'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSnipAndFleshMarks_RAW_URL = function() {
  return '/marking-data/snip-flesh-mark'
}
export const getSnipAndFleshMarks_TYPE = function() {
  return 'get'
}
export const getSnipAndFleshMarksURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/marking-data/snip-flesh-mark'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get spot on coronet options
 * request: getSpotOnCoronet
 * url: getSpotOnCoronetURL
 * method: getSpotOnCoronet_TYPE
 * raw_url: getSpotOnCoronet_RAW_URL
 */
export const getSpotOnCoronet = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/marking-data/spot-on-coronet'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSpotOnCoronet_RAW_URL = function() {
  return '/marking-data/spot-on-coronet'
}
export const getSpotOnCoronet_TYPE = function() {
  return 'get'
}
export const getSpotOnCoronetURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/marking-data/spot-on-coronet'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get star position options
 * request: getStarPositions
 * url: getStarPositionsURL
 * method: getStarPositions_TYPE
 * raw_url: getStarPositions_RAW_URL
 */
export const getStarPositions = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/marking-data/star-position'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStarPositions_RAW_URL = function() {
  return '/marking-data/star-position'
}
export const getStarPositions_TYPE = function() {
  return 'get'
}
export const getStarPositionsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/marking-data/star-position'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get star relation to whorl options
 * request: getStarRelationToWhorl
 * url: getStarRelationToWhorlURL
 * method: getStarRelationToWhorl_TYPE
 * raw_url: getStarRelationToWhorl_RAW_URL
 */
export const getStarRelationToWhorl = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/marking-data/star-relation-whorl'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStarRelationToWhorl_RAW_URL = function() {
  return '/marking-data/star-relation-whorl'
}
export const getStarRelationToWhorl_TYPE = function() {
  return 'get'
}
export const getStarRelationToWhorlURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/marking-data/star-relation-whorl'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get star size options
 * request: getStarSizes
 * url: getStarSizesURL
 * method: getStarSizes_TYPE
 * raw_url: getStarSizes_RAW_URL
 */
export const getStarSizes = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/marking-data/star-size'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStarSizes_RAW_URL = function() {
  return '/marking-data/star-size'
}
export const getStarSizes_TYPE = function() {
  return 'get'
}
export const getStarSizesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/marking-data/star-size'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get stripe options
 * request: getStripes
 * url: getStripesURL
 * method: getStripes_TYPE
 * raw_url: getStripes_RAW_URL
 */
export const getStripes = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/marking-data/stripe'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStripes_RAW_URL = function() {
  return '/marking-data/stripe'
}
export const getStripes_TYPE = function() {
  return 'get'
}
export const getStripesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/marking-data/stripe'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get under main whorl options
 * request: getUnderMainWhorl
 * url: getUnderMainWhorlURL
 * method: getUnderMainWhorl_TYPE
 * raw_url: getUnderMainWhorl_RAW_URL
 */
export const getUnderMainWhorl = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/marking-data/under-main-whorl'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUnderMainWhorl_RAW_URL = function() {
  return '/marking-data/under-main-whorl'
}
export const getUnderMainWhorl_TYPE = function() {
  return 'get'
}
export const getUnderMainWhorlURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/marking-data/under-main-whorl'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get under neck whorl options
 * request: getUnderNeckWhorls
 * url: getUnderNeckWhorlsURL
 * method: getUnderNeckWhorls_TYPE
 * raw_url: getUnderNeckWhorls_RAW_URL
 */
export const getUnderNeckWhorls = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/marking-data/under-neck-whorl'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUnderNeckWhorls_RAW_URL = function() {
  return '/marking-data/under-neck-whorl'
}
export const getUnderNeckWhorls_TYPE = function() {
  return 'get'
}
export const getUnderNeckWhorlsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/marking-data/under-neck-whorl'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get white marks options
 * request: getWhiteMarks
 * url: getWhiteMarksURL
 * method: getWhiteMarks_TYPE
 * raw_url: getWhiteMarks_RAW_URL
 */
export const getWhiteMarks = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/marking-data/white-marks'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getWhiteMarks_RAW_URL = function() {
  return '/marking-data/white-marks'
}
export const getWhiteMarks_TYPE = function() {
  return 'get'
}
export const getWhiteMarksURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/marking-data/white-marks'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all owners
 * request: getOwners
 * url: getOwnersURL
 * method: getOwners_TYPE
 * raw_url: getOwners_RAW_URL
 */
export const getOwners = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/owners'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOwners_RAW_URL = function() {
  return '/owners'
}
export const getOwners_TYPE = function() {
  return 'get'
}
export const getOwnersURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/owners'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Create or update an owner
 * request: createOrUpdateOwner
 * url: createOrUpdateOwnerURL
 * method: createOrUpdateOwner_TYPE
 * raw_url: createOrUpdateOwner_RAW_URL
 * @param body - 
 */
export const createOrUpdateOwner = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/owners'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createOrUpdateOwner_RAW_URL = function() {
  return '/owners'
}
export const createOrUpdateOwner_TYPE = function() {
  return 'post'
}
export const createOrUpdateOwnerURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/owners'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all farm names
 * request: getAllFarms
 * url: getAllFarmsURL
 * method: getAllFarms_TYPE
 * raw_url: getAllFarms_RAW_URL
 */
export const getAllFarms = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/owners/farms/all'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllFarms_RAW_URL = function() {
  return '/owners/farms/all'
}
export const getAllFarms_TYPE = function() {
  return 'get'
}
export const getAllFarmsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/owners/farms/all'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search owners by phrase
 * request: searchOwnerForHorseForm
 * url: searchOwnerForHorseFormURL
 * method: searchOwnerForHorseForm_TYPE
 * raw_url: searchOwnerForHorseForm_RAW_URL
 * @param phrase - 
 */
export const searchOwnerForHorseForm = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/owners/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['phrase'] !== undefined) {
    queryParameters['phrase'] = parameters['phrase']
  }
  if (parameters['phrase'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: phrase'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const searchOwnerForHorseForm_RAW_URL = function() {
  return '/owners/search'
}
export const searchOwnerForHorseForm_TYPE = function() {
  return 'get'
}
export const searchOwnerForHorseFormURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/owners/search'
  if (parameters['phrase'] !== undefined) {
    queryParameters['phrase'] = parameters['phrase']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search owners
 * request: searchOwner
 * url: searchOwnerURL
 * method: searchOwner_TYPE
 * raw_url: searchOwner_RAW_URL
 * @param body - 
 */
export const searchOwner = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/owners/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchOwner_RAW_URL = function() {
  return '/owners/search'
}
export const searchOwner_TYPE = function() {
  return 'post'
}
export const searchOwnerURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/owners/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count owners matching search criteria
 * request: searchOwnerCount
 * url: searchOwnerCountURL
 * method: searchOwnerCount_TYPE
 * raw_url: searchOwnerCount_RAW_URL
 * @param body - 
 */
export const searchOwnerCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/owners/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchOwnerCount_RAW_URL = function() {
  return '/owners/search/count'
}
export const searchOwnerCount_TYPE = function() {
  return 'post'
}
export const searchOwnerCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/owners/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete an owner
 * request: deleteOwner
 * url: deleteOwnerURL
 * method: deleteOwner_TYPE
 * raw_url: deleteOwner_RAW_URL
 * @param id - 
 */
export const deleteOwner = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/owners/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteOwner_RAW_URL = function() {
  return '/owners/{id}'
}
export const deleteOwner_TYPE = function() {
  return 'delete'
}
export const deleteOwnerURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/owners/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get owner by ID
 * request: getOwner
 * url: getOwnerURL
 * method: getOwner_TYPE
 * raw_url: getOwner_RAW_URL
 * @param id - 
 */
export const getOwner = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/owners/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOwner_RAW_URL = function() {
  return '/owners/{id}'
}
export const getOwner_TYPE = function() {
  return 'get'
}
export const getOwnerURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/owners/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Refresh access token using refresh token cookie
 * request: refreshToken
 * url: refreshTokenURL
 * method: refreshToken_TYPE
 * raw_url: refreshToken_RAW_URL
 * @param refreshToken - 
 */
export const refreshToken = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/refresh-token'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const refreshToken_RAW_URL = function() {
  return '/refresh-token'
}
export const refreshToken_TYPE = function() {
  return 'post'
}
export const refreshTokenURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/refresh-token'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate breeders report
 * request: getBreedersReport
 * url: getBreedersReportURL
 * method: getBreedersReport_TYPE
 * raw_url: getBreedersReport_RAW_URL
 * @param body - 
 */
export const getBreedersReport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/report/breeders'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getBreedersReport_RAW_URL = function() {
  return '/report/breeders'
}
export const getBreedersReport_TYPE = function() {
  return 'post'
}
export const getBreedersReportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/report/breeders'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate broodmares produce report
 * request: getBroodmaresProduceReport
 * url: getBroodmaresProduceReportURL
 * method: getBroodmaresProduceReport_TYPE
 * raw_url: getBroodmaresProduceReport_RAW_URL
 * @param body - 
 */
export const getBroodmaresProduceReport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/report/broodmares-produce'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getBroodmaresProduceReport_RAW_URL = function() {
  return '/report/broodmares-produce'
}
export const getBroodmaresProduceReport_TYPE = function() {
  return 'post'
}
export const getBroodmaresProduceReportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/report/broodmares-produce'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate covering report
 * request: getCoveringReport
 * url: getCoveringReportURL
 * method: getCoveringReport_TYPE
 * raw_url: getCoveringReport_RAW_URL
 * @param body - 
 */
export const getCoveringReport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/report/covering'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getCoveringReport_RAW_URL = function() {
  return '/report/covering'
}
export const getCoveringReport_TYPE = function() {
  return 'post'
}
export const getCoveringReportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/report/covering'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate deceased horses report
 * request: getDeceasedReport
 * url: getDeceasedReportURL
 * method: getDeceasedReport_TYPE
 * raw_url: getDeceasedReport_RAW_URL
 * @param body - 
 */
export const getDeceasedReport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/report/deceased'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getDeceasedReport_RAW_URL = function() {
  return '/report/deceased'
}
export const getDeceasedReport_TYPE = function() {
  return 'post'
}
export const getDeceasedReportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/report/deceased'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate horse report
 * request: getHorseReport
 * url: getHorseReportURL
 * method: getHorseReport_TYPE
 * raw_url: getHorseReport_RAW_URL
 * @param body - 
 */
export const getHorseReport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/report/horse'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getHorseReport_RAW_URL = function() {
  return '/report/horse'
}
export const getHorseReport_TYPE = function() {
  return 'post'
}
export const getHorseReportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/report/horse'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate exported horse report
 * request: getExportedHorseReport
 * url: getExportedHorseReportURL
 * method: getExportedHorseReport_TYPE
 * raw_url: getExportedHorseReport_RAW_URL
 * @param body - 
 */
export const getExportedHorseReport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/report/horse-exported'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getExportedHorseReport_RAW_URL = function() {
  return '/report/horse-exported'
}
export const getExportedHorseReport_TYPE = function() {
  return 'post'
}
export const getExportedHorseReportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/report/horse-exported'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate imported horse report
 * request: getImportedHorseReport
 * url: getImportedHorseReportURL
 * method: getImportedHorseReport_TYPE
 * raw_url: getImportedHorseReport_RAW_URL
 * @param body - 
 */
export const getImportedHorseReport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/report/horse-imported'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getImportedHorseReport_RAW_URL = function() {
  return '/report/horse-imported'
}
export const getImportedHorseReport_TYPE = function() {
  return 'post'
}
export const getImportedHorseReportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/report/horse-imported'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate local breed horse report
 * request: getLocalBreedHorseReport
 * url: getLocalBreedHorseReportURL
 * method: getLocalBreedHorseReport_TYPE
 * raw_url: getLocalBreedHorseReport_RAW_URL
 * @param body - 
 */
export const getLocalBreedHorseReport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/report/horse-local-breed'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getLocalBreedHorseReport_RAW_URL = function() {
  return '/report/horse-local-breed'
}
export const getLocalBreedHorseReport_TYPE = function() {
  return 'post'
}
export const getLocalBreedHorseReportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/report/horse-local-breed'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate lab activity report
 * request: getLabActivityReport
 * url: getLabActivityReportURL
 * method: getLabActivityReport_TYPE
 * raw_url: getLabActivityReport_RAW_URL
 * @param body - 
 */
export const getLabActivityReport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/report/lab'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getLabActivityReport_RAW_URL = function() {
  return '/report/lab'
}
export const getLabActivityReport_TYPE = function() {
  return 'post'
}
export const getLabActivityReportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/report/lab'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate owner report
 * request: getOwnerReport
 * url: getOwnerReportURL
 * method: getOwnerReport_TYPE
 * raw_url: getOwnerReport_RAW_URL
 * @param ownerId - 
 */
export const getOwnerReport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/report/owner/{ownerId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{ownerId}', `${parameters['ownerId']}`)
  if (parameters['ownerId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ownerId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getOwnerReport_RAW_URL = function() {
  return '/report/owner/{ownerId}'
}
export const getOwnerReport_TYPE = function() {
  return 'get'
}
export const getOwnerReportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/report/owner/{ownerId}'
  path = path.replace('{ownerId}', `${parameters['ownerId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate owners report
 * request: getOwnersReport
 * url: getOwnersReportURL
 * method: getOwnersReport_TYPE
 * raw_url: getOwnersReport_RAW_URL
 * @param body - 
 */
export const getOwnersReport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/report/owners'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getOwnersReport_RAW_URL = function() {
  return '/report/owners'
}
export const getOwnersReport_TYPE = function() {
  return 'post'
}
export const getOwnersReportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/report/owners'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate stallions agreement report
 * request: getStallionsAgreementReport
 * url: getStallionsAgreementReportURL
 * method: getStallionsAgreementReport_TYPE
 * raw_url: getStallionsAgreementReport_RAW_URL
 * @param body - 
 */
export const getStallionsAgreementReport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/report/stallions-agreement'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getStallionsAgreementReport_RAW_URL = function() {
  return '/report/stallions-agreement'
}
export const getStallionsAgreementReport_TYPE = function() {
  return 'post'
}
export const getStallionsAgreementReportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/report/stallions-agreement'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate stallions progeny report
 * request: getStallionsProgenyReport
 * url: getStallionsProgenyReportURL
 * method: getStallionsProgenyReport_TYPE
 * raw_url: getStallionsProgenyReport_RAW_URL
 * @param body - 
 */
export const getStallionsProgenyReport = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/report/stallions-progeny'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const getStallionsProgenyReport_RAW_URL = function() {
  return '/report/stallions-progeny'
}
export const getStallionsProgenyReport_TYPE = function() {
  return 'post'
}
export const getStallionsProgenyReportURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/report/stallions-progeny'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Create or update a season
 * request: createOrUpdateSeason
 * url: createOrUpdateSeasonURL
 * method: createOrUpdateSeason_TYPE
 * raw_url: createOrUpdateSeason_RAW_URL
 * @param body - 
 */
export const createOrUpdateSeason = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/season'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createOrUpdateSeason_RAW_URL = function() {
  return '/season'
}
export const createOrUpdateSeason_TYPE = function() {
  return 'post'
}
export const createOrUpdateSeasonURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/season'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get all active seasons
 * request: getActiveSeasons
 * url: getActiveSeasonsURL
 * method: getActiveSeasons_TYPE
 * raw_url: getActiveSeasons_RAW_URL
 */
export const getActiveSeasons = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/season/active'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getActiveSeasons_RAW_URL = function() {
  return '/season/active'
}
export const getActiveSeasons_TYPE = function() {
  return 'get'
}
export const getActiveSeasonsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/season/active'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search seasons
 * request: searchSeason
 * url: searchSeasonURL
 * method: searchSeason_TYPE
 * raw_url: searchSeason_RAW_URL
 * @param body - 
 */
export const searchSeason = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/season/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchSeason_RAW_URL = function() {
  return '/season/search'
}
export const searchSeason_TYPE = function() {
  return 'post'
}
export const searchSeasonURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/season/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count seasons matching search criteria
 * request: searchSeasonCount
 * url: searchSeasonCountURL
 * method: searchSeasonCount_TYPE
 * raw_url: searchSeasonCount_RAW_URL
 * @param body - 
 */
export const searchSeasonCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/season/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchSeasonCount_RAW_URL = function() {
  return '/season/search/count'
}
export const searchSeasonCount_TYPE = function() {
  return 'post'
}
export const searchSeasonCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/season/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete a season
 * request: deleteSeason
 * url: deleteSeasonURL
 * method: deleteSeason_TYPE
 * raw_url: deleteSeason_RAW_URL
 * @param id - 
 */
export const deleteSeason = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/season/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteSeason_RAW_URL = function() {
  return '/season/{id}'
}
export const deleteSeason_TYPE = function() {
  return 'delete'
}
export const deleteSeasonURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/season/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get a season by ID
 * request: getSeason
 * url: getSeasonURL
 * method: getSeason_TYPE
 * raw_url: getSeason_RAW_URL
 * @param id - 
 */
export const getSeason = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/season/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getSeason_RAW_URL = function() {
  return '/season/{id}'
}
export const getSeason_TYPE = function() {
  return 'get'
}
export const getSeasonURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/season/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Generate studbook PDF
 * request: generateStudbook
 * url: generateStudbookURL
 * method: generateStudbook_TYPE
 * raw_url: generateStudbook_RAW_URL
 * @param volume - 
 * @param yearFrom - 
 * @param yearTo - 
 */
export const generateStudbook = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/studbook/generate/{volume}/{yearFrom}/{yearTo}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{volume}', `${parameters['volume']}`)
  if (parameters['volume'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: volume'))
  }
  path = path.replace('{yearFrom}', `${parameters['yearFrom']}`)
  if (parameters['yearFrom'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: yearFrom'))
  }
  path = path.replace('{yearTo}', `${parameters['yearTo']}`)
  if (parameters['yearTo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: yearTo'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const generateStudbook_RAW_URL = function() {
  return '/studbook/generate/{volume}/{yearFrom}/{yearTo}'
}
export const generateStudbook_TYPE = function() {
  return 'post'
}
export const generateStudbookURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/studbook/generate/{volume}/{yearFrom}/{yearTo}'
  path = path.replace('{volume}', `${parameters['volume']}`)
  path = path.replace('{yearFrom}', `${parameters['yearFrom']}`)
  path = path.replace('{yearTo}', `${parameters['yearTo']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get studbook data for breed and year range
 * request: getStudbookData
 * url: getStudbookDataURL
 * method: getStudbookData_TYPE
 * raw_url: getStudbookData_RAW_URL
 * @param yearFrom - 
 * @param yearTo - 
 * @param breed - 
 */
export const getStudbookData = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/studbook/studbook-data/{breed}/{yearFrom}/{yearTo}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{yearFrom}', `${parameters['yearFrom']}`)
  if (parameters['yearFrom'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: yearFrom'))
  }
  path = path.replace('{yearTo}', `${parameters['yearTo']}`)
  if (parameters['yearTo'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: yearTo'))
  }
  path = path.replace('{breed}', `${parameters['breed']}`)
  if (parameters['breed'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: breed'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStudbookData_RAW_URL = function() {
  return '/studbook/studbook-data/{breed}/{yearFrom}/{yearTo}'
}
export const getStudbookData_TYPE = function() {
  return 'get'
}
export const getStudbookDataURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/studbook/studbook-data/{breed}/{yearFrom}/{yearTo}'
  path = path.replace('{yearFrom}', `${parameters['yearFrom']}`)
  path = path.replace('{yearTo}', `${parameters['yearTo']}`)
  path = path.replace('{breed}', `${parameters['breed']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Cancel studbook generation task
 * request: cancelTask
 * url: cancelTaskURL
 * method: cancelTask_TYPE
 * raw_url: cancelTask_RAW_URL
 */
export const cancelTask = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/studbook/task/cancel'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const cancelTask_RAW_URL = function() {
  return '/studbook/task/cancel'
}
export const cancelTask_TYPE = function() {
  return 'post'
}
export const cancelTaskURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/studbook/task/cancel'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get current studbook generation task status
 * request: getTaskStatus
 * url: getTaskStatusURL
 * method: getTaskStatus_TYPE
 * raw_url: getTaskStatus_RAW_URL
 */
export const getTaskStatus = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/studbook/task/status'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTaskStatus_RAW_URL = function() {
  return '/studbook/task/status'
}
export const getTaskStatus_TYPE = function() {
  return 'get'
}
export const getTaskStatusURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/studbook/task/status'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search users for select values
 * request: getUsers
 * url: getUsersURL
 * method: getUsers_TYPE
 * raw_url: getUsers_RAW_URL
 * @param query - 
 */
export const getUsers = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['query'] !== undefined) {
    queryParameters['query'] = parameters['query']
  }
  if (parameters['query'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: query'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUsers_RAW_URL = function() {
  return '/users'
}
export const getUsers_TYPE = function() {
  return 'get'
}
export const getUsersURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users'
  if (parameters['query'] !== undefined) {
    queryParameters['query'] = parameters['query']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Create or update a user
 * request: createOrUpdateUser
 * url: createOrUpdateUserURL
 * method: createOrUpdateUser_TYPE
 * raw_url: createOrUpdateUser_RAW_URL
 * @param body - 
 */
export const createOrUpdateUser = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createOrUpdateUser_RAW_URL = function() {
  return '/users'
}
export const createOrUpdateUser_TYPE = function() {
  return 'post'
}
export const createOrUpdateUserURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search controllers by phrase
 * request: searchControllerByPhrase
 * url: searchControllerByPhraseURL
 * method: searchControllerByPhrase_TYPE
 * raw_url: searchControllerByPhrase_RAW_URL
 * @param phrase - 
 */
export const searchControllerByPhrase = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/controller/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['phrase'] !== undefined) {
    queryParameters['phrase'] = parameters['phrase']
  }
  if (parameters['phrase'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: phrase'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const searchControllerByPhrase_RAW_URL = function() {
  return '/users/controller/search'
}
export const searchControllerByPhrase_TYPE = function() {
  return 'get'
}
export const searchControllerByPhraseURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/controller/search'
  if (parameters['phrase'] !== undefined) {
    queryParameters['phrase'] = parameters['phrase']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Change user password
 * request: changePassword
 * url: changePasswordURL
 * method: changePassword_TYPE
 * raw_url: changePassword_RAW_URL
 * @param body - 
 */
export const changePassword = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/password/change'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const changePassword_RAW_URL = function() {
  return '/users/password/change'
}
export const changePassword_TYPE = function() {
  return 'post'
}
export const changePasswordURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/password/change'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Send password reminder email
 * request: remindPassword
 * url: remindPasswordURL
 * method: remindPassword_TYPE
 * raw_url: remindPassword_RAW_URL
 * @param body - 
 */
export const remindPassword = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/password/remind'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const remindPassword_RAW_URL = function() {
  return '/users/password/remind'
}
export const remindPassword_TYPE = function() {
  return 'post'
}
export const remindPasswordURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/password/remind'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get available user roles
 * request: getUserRoles
 * url: getUserRolesURL
 * method: getUserRoles_TYPE
 * raw_url: getUserRoles_RAW_URL
 */
export const getUserRoles = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/roles'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUserRoles_RAW_URL = function() {
  return '/users/roles'
}
export const getUserRoles_TYPE = function() {
  return 'get'
}
export const getUserRolesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/roles'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Search users
 * request: searchUser
 * url: searchUserURL
 * method: searchUser_TYPE
 * raw_url: searchUser_RAW_URL
 * @param body - 
 */
export const searchUser = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/search'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchUser_RAW_URL = function() {
  return '/users/search'
}
export const searchUser_TYPE = function() {
  return 'post'
}
export const searchUserURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/search'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Count users matching search criteria
 * request: searchUserCount
 * url: searchUserCountURL
 * method: searchUserCount_TYPE
 * raw_url: searchUserCount_RAW_URL
 * @param body - 
 */
export const searchUserCount = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/search/count'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['body'] !== undefined) {
    body = parameters['body']
  }
  if (parameters['body'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: body'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const searchUserCount_RAW_URL = function() {
  return '/users/search/count'
}
export const searchUserCount_TYPE = function() {
  return 'post'
}
export const searchUserCountURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/search/count'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Delete a user
 * request: deleteUser
 * url: deleteUserURL
 * method: deleteUser_TYPE
 * raw_url: deleteUser_RAW_URL
 * @param id - 
 */
export const deleteUser = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteUser_RAW_URL = function() {
  return '/users/{id}'
}
export const deleteUser_TYPE = function() {
  return 'delete'
}
export const deleteUserURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * Get a user by ID
 * request: getUser
 * url: getUserURL
 * method: getUser_TYPE
 * raw_url: getUser_RAW_URL
 * @param id - 
 */
export const getUser = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUser_RAW_URL = function() {
  return '/users/{id}'
}
export const getUser_TYPE = function() {
  return 'get'
}
export const getUserURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}